export const fr = {
  'common.language': 'Langue',
  'common.environment': 'Environnement',
  'is.reachable': 'est accessible',
  'is.not.reachable': 'n\'est pas accessible',
  'not.found.message': 'Cette page n\'existe pas.',
  'common.back': 'Retour',
  'an.error.occurred': 'Une erreur est survenue',
  'common.back-office': 'Back-office',
  'common.routing.game-mechanics': 'Mécaniques de jeu',
  'common.routing.dialog': 'Dialogue',
  'common.routing.image': 'Clique image',
  'common.routing.multiple-choice': 'QCM',
  'common.routing.reorder': 'Reorder',
  'common.routing.single-choice': 'QCU',
  'common.routing.users': 'Utilisateurs',
  'common.routing.learnerProfile': 'Fiche utilisateur',
  'common.routing.groups': 'Groupes',
  'common.routing.files': 'Fichiers',
  'common.routing.dashboard': 'Tableau de bord',
  'common.routing.statistics': 'Statistiques',
  'common.routing.sessions': 'Sessions',
  'common.routing.account': 'Mon compte',
  'common.routing.settings': 'Personnalisation',
  'common.routing.modules': 'Modules',
  'common.routing.certificates': 'Attestations',
  'common.routing.reminders': 'Rappels email',
  'common.routing.survey': 'Questionnaire de satisfaction',
  'common.routing.documents': 'Documents',
  'common.routing.quality': 'Amélioration continue',
  'common.routing.accommodations': 'Accueil handicap',
  'common.routing.complaints': 'Réclamations',
  'documents.title': 'Documents',
  'documents.intro': 'Les documents remis à vos apprenants : règlement intérieur, programme, conditions générales, livret d\'accueil. Chacun les retrouve sur l\'écran de son parcours et déclare en avoir pris connaissance : c\'est la preuve de remise que demande Qualiopi (indicateur 9).',
  'documents.empty': 'Aucun document. Déposez votre règlement intérieur, votre livret d\'accueil ou le programme de vos formations.',
  'documents.allSessions': 'Tous les parcours',
  'documents.required': 'À accepter avant de commencer',
  'documents.requiredHelp': 'L\'apprenant ne peut ouvrir aucun module tant qu\'il n\'a pas déclaré en avoir pris connaissance. Un apprenant qui a déjà commencé n\'est pas bloqué.',
  'documents.requiredBadge': 'À accepter',
  'documents.optional': 'Consultable',
  'documents.download': 'Télécharger',
  'documents.archive': 'Archiver',
  'documents.saved': 'Document enregistré.',
  'documents.uploaded': 'Document déposé.',
  'documents.archived': 'Document archivé.',
  'documents.saveFailed': 'L\'enregistrement a échoué. Réessayez.',
  'documents.downloadFailed': 'Le téléchargement a échoué.',
  'documents.column.title': 'Titre',
  'documents.column.session': 'Parcours',
  'documents.column.required': 'Lecture',
  'documents.column.acks': 'Accusés de lecture',
  'documents.column.actions': 'Actions',
  'documents.new.button': 'Ajouter un document',
  'documents.new.title': 'Ajouter un document',
  'documents.new.description': 'Un PDF de 10 Mo au plus. Choisissez pour quel parcours, ou pour tous, et s\'il doit être accepté avant de commencer.',
  'documents.new.pick': 'Choisir un PDF',
  'documents.new.noFile': 'Aucun fichier choisi',
  'documents.new.processing': 'Enregistrement du document…',
  'documents.new.submit': 'Déposer le document',
  'documents.error.notPdf': 'Ce fichier n\'est pas un PDF.',
  'documents.error.tooLarge': 'Le fichier dépasse 10 Mo.',
  'documents.error.limit': 'Vous avez atteint 50 documents : archivez-en un avant d\'en ajouter.',
  'documents.error.noFile': 'Choisissez un fichier.',
  'documents.error.noTitle': 'Donnez un titre au document.',
  'documents.error.network': 'L\'envoi n\'a pas abouti. Vérifiez votre connexion et réessayez.',
  'documents.error.unknown': 'Le dépôt a échoué. Réessayez.',
  'documents.acks.open': 'Voir les accusés de lecture',
  'documents.acks.count_one': '{{count}} apprenant',
  'documents.acks.count_other': '{{count}} apprenants',
  'documents.acks.title': 'Accusés de lecture — {{title}}',
  'documents.acks.description': 'Les apprenants qui ont déclaré avoir pris connaissance du document, et quand.',
  'documents.acks.empty': 'Personne n\'a encore déclaré en avoir pris connaissance.',
  'documents.acks.learner': 'Apprenant',
  'documents.acks.at': 'Pris connaissance le',
  'documents.acks.export': 'Exporter (CSV)',
  'documents.acks.fileName': 'Accusés de lecture',
  'documents.archiveConfirm.title': 'Archiver ce document ?',
  'documents.archiveConfirm.body': 'Les apprenants ne verront plus « {{title}} ». Ses accusés de lecture sont conservés, comme preuve de remise.',
  'quality.title': 'Amélioration continue',
  'quality.intro': 'Les actions décidées à partir des retours (questionnaires, réclamations, abandons, audits) et leur effet mesuré, puis les risques qui pèsent sur la qualité de vos formations. Visible des seuls administrateurs.',
  'quality.tabs': 'Registre',
  'quality.export': 'Exporter (CSV)',
  'quality.open': 'Ouvrir',
  'quality.saved': 'Enregistré.',
  'quality.saveFailed': 'L\'enregistrement a échoué. Réessayez.',
  'quality.column.title': 'Intitulé',
  'quality.column.status': 'État',
  'quality.column.owner': 'Responsable',
  'quality.column.actions': 'Actions',
  'quality.origin.survey': 'Questionnaire',
  'quality.origin.complaint': 'Réclamation',
  'quality.origin.dropout': 'Abandon',
  'quality.origin.audit': 'Audit',
  'quality.origin.review': 'Revue interne',
  'quality.origin.other': 'Autre',
  'quality.actionStatus.planned': 'Prévue',
  'quality.actionStatus.inProgress': 'En cours',
  'quality.actionStatus.done': 'Réalisée',
  'quality.actionStatus.cancelled': 'Abandonnée',
  'quality.riskStatus.open': 'À traiter',
  'quality.riskStatus.mitigated': 'Maîtrisé',
  'quality.riskStatus.closed': 'Clos',
  'quality.score.low': 'faible',
  'quality.score.medium': 'moyen',
  'quality.score.high': 'fort',
  'quality.actions.title': 'Actions d\'amélioration',
  'quality.actions.empty': 'Aucune action pour l\'instant. Notez ici ce que vous décidez à partir des retours, et ce que cela a changé.',
  'quality.actions.fileName': 'Actions d\'amélioration',
  'quality.actions.createdOn': 'Créée le {{date}}',
  'quality.actions.doneOn': 'Réalisée le {{date}}',
  'quality.actions.originPlaceholder': 'D\'où vient cette action ?',
  'quality.actions.descriptionHelp': 'Le constat de départ et ce qui est décidé.',
  'quality.actions.effectHelp': 'Ce que l\'action a changé, mesuré si possible (satisfaction, taux d\'abandon, réclamations…).',
  'quality.actions.new.title': 'Nouvelle action d\'amélioration',
  'quality.actions.new.description': 'Une décision prise à partir d\'un retour : précisez son origine, ce qui est décidé, qui la porte et pour quand.',
  'quality.actions.new.button': 'Nouvelle action',
  'quality.actions.new.submit': 'Enregistrer l\'action',
  'quality.actions.column.origin': 'Origine',
  'quality.actions.column.description': 'Constat et décision',
  'quality.actions.column.dueDate': 'Échéance',
  'quality.actions.column.effect': 'Effet mesuré',
  'quality.actions.column.createdAt': 'Créée le',
  'quality.actions.column.doneAt': 'Réalisée le',
  'quality.risks.title': 'Risques qualité',
  'quality.risks.empty': 'Aucun risque identifié. Listez ce qui pourrait dégrader vos formations : formateur indisponible, contenu obsolète, panne de la plateforme…',
  'quality.risks.fileName': 'Risques qualité',
  'quality.risks.severityHelp': 'Gravité = probabilité × impact, de 1 à 9 : ici {{severity}}.',
  'quality.risks.severityValue': '{{severity}} ({{likelihood}} × {{impact}})',
  'quality.risks.new.title': 'Nouveau risque',
  'quality.risks.new.button': 'Nouveau risque',
  'quality.risks.new.submit': 'Enregistrer le risque',
  'quality.risks.column.description': 'Description',
  'quality.risks.column.likelihood': 'Probabilité',
  'quality.risks.column.impact': 'Impact',
  'quality.risks.column.severity': 'Gravité',
  'quality.risks.column.mitigation': 'Mesure de maîtrise',
  'quality.risks.column.reviewedAt': 'Dernière revue',
  'accommodation.title': 'Besoin d\'un aménagement ?',
  'accommodation.intro': 'Si vous avez besoin d\'une adaptation pour suivre vos formations (temps supplémentaire, sous-titres, texte plus grand…), dites-le à votre organisme.',
  'accommodation.referent': 'Votre référent handicap : {{who}}',
  'accommodation.noReferent': 'Votre organisme n\'a pas encore indiqué de référent ; votre demande lui parvient quand même.',
  'accommodation.needs': 'De quoi avez-vous besoin ?',
  'accommodation.needsHelp': 'Décrivez seulement l\'adaptation souhaitée : inutile de préciser votre situation de santé.',
  'accommodation.consent': 'J\'accepte que {{org}} utilise ces informations pour adapter ma formation. Seuls ses administrateurs les verront, et je peux retirer ma demande à tout moment.',
  'accommodation.send': 'Envoyer ma demande',
  'accommodation.yourRequest': 'Votre demande',
  'accommodation.response': 'Réponse de votre organisme :',
  'accommodation.edit': 'Modifier',
  'accommodation.withdraw': 'Retirer ma demande',
  'accommodation.withdrawConfirm.title': 'Retirer votre demande ?',
  'accommodation.withdrawConfirm.body': 'Elle sera effacée, ainsi que la réponse de votre organisme. Vous pourrez en faire une nouvelle.',
  'accommodation.sent': 'Demande envoyée.',
  'accommodation.withdrawn': 'Demande retirée et effacée.',
  'accommodation.failed': 'L\'enregistrement a échoué. Réessayez.',
  'accommodations.title': 'Accueil handicap',
  'accommodations.intro': 'Le référent handicap de votre organisme, et les besoins d\'aménagement que vos apprenants vous ont confiés (Qualiopi, indicateur 26). Ce sont des données de santé : seuls les administrateurs les voient, et l\'apprenant peut retirer sa demande à tout moment, ce qui l\'efface.',
  'accommodations.requests': 'Demandes d\'aménagement',
  'accommodations.empty': 'Aucune demande. Vos apprenants peuvent en faire une depuis « Mon compte ».',
  'accommodations.open': 'Traiter',
  'accommodations.saved': 'Demande enregistrée.',
  'accommodations.saveFailed': 'L\'enregistrement a échoué. Réessayez.',
  'accommodations.sentOn': 'Demande envoyée ou modifiée le {{date}}',
  'accommodations.response': 'Ce qui est mis en place',
  'accommodations.responseHelp': 'L\'apprenant lit cette réponse sur « Mon compte ». Dites ce qui change pour lui, pas plus.',
  'accommodations.markHandled': 'Demande traitée',
  'accommodations.handledOn': 'Traitée le {{date}}',
  'accommodations.status.pending': 'À traiter',
  'accommodations.status.handled': 'Traitée',
  'accommodations.column.learner': 'Apprenant',
  'accommodations.column.needs': 'Besoin',
  'accommodations.column.updatedAt': 'Depuis le',
  'accommodations.column.status': 'État',
  'accommodations.column.actions': 'Actions',
  'accommodations.referent.title': 'Référent handicap',
  'accommodations.referent.help': 'La personne à qui vos apprenants peuvent s\'adresser. Son nom et son contact s\'affichent sur leur page « Mon compte ».',
  'accommodations.referent.name': 'Nom',
  'accommodations.referent.contact': 'Contact (e-mail ou téléphone)',
  'accommodations.referent.saved': 'Référent enregistré.',
  'complaints.title': 'Réclamations',
  'complaints.intro': 'Demandes, réclamations et signalements reçus par votre organisme, et leur traitement. Visible des seuls administrateurs.',
  'complaints.empty': 'Aucune entrée pour ces filtres.',
  'complaints.export': 'Exporter (CSV)',
  'complaints.open': 'Traiter',
  'complaints.saved': 'Réclamation mise à jour',
  'complaints.created': 'Réclamation enregistrée',
  'complaints.saveFailed': 'La réclamation n\'a pas pu être enregistrée.',
  'complaints.responseHelp': 'La réponse apportée, pour la trace : elle n\'est pas envoyée à l\'apprenant.',
  'complaints.respondedOn': 'Répondue le {{date}}',
  'complaints.resolvedOn': 'Résolue le {{date}}',
  'complaints.receivedFrom': 'Reçue le {{date}} de {{author}} ({{origin}})',
  'complaints.categoryPlaceholder': 'Choisir la nature',
  'complaints.author.none': 'Auteur non rattaché',
  'complaints.category.question': 'Question',
  'complaints.category.pedagogical': 'Pédagogique',
  'complaints.category.technical': 'Technique',
  'complaints.category.administrative': 'Administrative',
  'complaints.category.report': 'Signalement (violence, harcèlement, discrimination)',
  'complaints.category.other': 'Autre',
  'complaints.status.open': 'Ouverte',
  'complaints.status.inProgress': 'En cours',
  'complaints.status.resolved': 'Résolue',
  'complaints.origin.contactForm': 'centre d\'aide',
  'complaints.origin.manual': 'saisie manuelle',
  'complaints.column.receivedAt': 'Reçue le',
  'complaints.column.category': 'Nature',
  'complaints.column.status': 'État',
  'complaints.column.origin': 'Origine',
  'complaints.column.author': 'Auteur',
  'complaints.column.subject': 'Objet',
  'complaints.column.message': 'Message',
  'complaints.column.response': 'Réponse apportée',
  'complaints.column.respondedAt': 'Répondue le',
  'complaints.column.resolvedAt': 'Résolue le',
  'complaints.column.actions': 'Actions',
  'complaints.filter.allStatuses': 'Tous les états',
  'complaints.filter.allCategories': 'Toutes les natures',
  'complaints.new.button': 'Saisir une réclamation',
  'complaints.new.title': 'Saisir une réclamation',
  'complaints.new.description': 'Une réclamation reçue hors de l\'app : courrier, téléphone, entretien.',
  'complaints.new.submit': 'Enregistrer la réclamation',
  'contact.category': 'Nature de votre demande',
  'contact.category.help': 'Un signalement (violence, harcèlement, discrimination) n\'est lu que par les administrateurs de votre organisme, jamais par vos formateurs.',
  'common.routing.organizations': 'Organisations',
  'common.routing.trial-requests': 'Demandes d\'essai',
  'common.routing.billing': 'Facturation',
  'common.routing.trainer-capabilities': 'Droits du formateur',
  'common.routing.webhooks': 'Webhooks',
  'common.routing.sso': 'Authentification SSO',
  'common.french': 'Français',
  'common.english': 'Anglais',
  'theme.dark': 'Mode sombre',
  'theme.light': 'Mode clair',
  'common.logout': 'Déconnexion',
  'common.users': 'Utilisateurs',
  'common.learners': 'Apprenants',
  'common.group': 'Groupe',
  'common.groups': 'Groupes',
  'common.description': 'Description',
  'common.files': 'Fichiers',
  'common.rowsPerPage': 'Lignes par page',
  'common.administration': 'Administration',
  'nav.group.training': 'Formation',
  'nav.group.learners': 'Apprenants',
  'common.menu': 'Menu',
  'file-upload.success': 'Fichier téléchargé avec succès.',
  'file-upload.failed': 'Fichier non téléchargé.',
  'no.files': 'Aucun fichier.',
  'start-by-uploading-a-file-using-the-button-below': 'Commencez par télécharger un fichier en utilisant le bouton ci-dessous.',
  'common.email': 'Adresse email',
  'common.username': 'Pseudo',
  'common.firstname': 'Prénom',
  'common.lastname': 'Nom',
  'common.role': 'Rôle',
  'role.Admin': 'Administrateur',
  'role.Formateur': 'Formateur',
  'role.User': 'Apprenant',
  'role.SuperAdmin': 'Opérateur plateforme',
  'account.title': 'Mon compte',
  'account.identity.title': 'Identité',
  'account.identity.description': 'Votre prénom et votre nom, tels qu\'ils apparaissent dans l\'application et sur vos attestations.',
  'account.identity.saved': 'Vos informations sont enregistrées.',
  'account.profile.title': 'Mon profil',
  'account.profile.organization': 'Organisation',
  'account.profile.lastConnection': 'Dernière connexion',
  'account.error.nameRequired': 'Le prénom et le nom sont obligatoires.',
  'account.error.nameTooLong': 'Le prénom et le nom ne dépassent pas 100 caractères.',
  'account.error.impersonation': 'Vous consultez ce compte à la place de son titulaire : il ne peut pas être modifié.',
  'account.error.currentPassword': 'Le mot de passe actuel est incorrect.',
  'account.error.noLocalPassword': 'Ce compte se connecte sans mot de passe : il n\'y en a pas à changer.',
  'account.error.generic': 'L\'enregistrement a échoué. Réessayez.',
  'password.tooShort': 'Au moins 8 caractères.',
  'account.password.title': 'Mot de passe',
  'account.password.description': 'Changer votre mot de passe vous déconnecte de vos autres appareils. Cette session reste ouverte.',
  'account.password.current': 'Mot de passe actuel',
  'account.password.new': 'Nouveau mot de passe',
  'account.password.submit': 'Changer le mot de passe',
  'account.password.saved': 'Votre mot de passe est changé.',
  'account.preferences.title': 'Préférences',
  'account.preferences.description': 'Langue et apparence de l\'application sur cet appareil.',
  'account.preferences.theme': 'Thème',
  'account.preferences.theme.light': 'Clair',
  'account.preferences.theme.dark': 'Sombre',
  'account.preferences.theme.system': 'Système',
  'contact.title': 'Besoin d\'aide ?',
  'contact.recipient.admins': 'Votre message part aux administrateurs de votre organisation.',
  'contact.recipient.support': 'Votre message part au support Studeva.',
  'contact.subject': 'Sujet',
  'contact.message': 'Message',
  'contact.send': 'Envoyer',
  'contact.sent': 'Votre demande est envoyée. On vous répond par e-mail.',
  'contact.attachment.label': 'Capture d\'écran (facultative)',
  'contact.attachment.choose': 'Joindre une capture',
  'contact.attachment.remove': 'Retirer la capture',
  'contact.attachment.hint': 'PNG ou JPEG, 1 Mo au plus.',
  'contact.attachment.tooLarge': 'La capture dépasse 1 Mo.',
  'contact.attachment.invalidType': 'La capture doit être une image PNG ou JPEG.',
  'contact.error.subjectRequired': 'Indiquez un sujet.',
  'contact.error.subjectTooLong': 'Le sujet ne dépasse pas 150 caractères.',
  'contact.error.messageRequired': 'Écrivez votre message.',
  'contact.error.messageTooLong': 'Le message ne dépasse pas 5 000 caractères.',
  'contact.error.tooMany': 'Trop de demandes en peu de temps. Réessayez dans quelques minutes.',
  'contact.error.sendFailed': 'L\'envoi a échoué. Réessayez dans un instant.',
  'tour.next': 'Suivant',
  'tour.prev': 'Précédent',
  'tour.done': 'Terminer',
  'tour.progress': '{{current}} sur {{total}}',
  'tour.unavailable': 'Cet écran n\'a pas pu être présenté. Réessayez dans un instant.',
  'help.title': 'Centre d\'aide',
  'help.intro': 'Chaque visite ouvre l\'écran concerné et vous en présente les éléments, pas à pas, sur l\'interface réelle.',
  'help.tours.title': 'Visites guidées',
  'help.tours.empty': 'Aucune visite n\'est encore disponible pour votre rôle.',
  'help.tour.start': 'Lancer la visite',
  'help.tour.startNamed': 'Lancer la visite : {{name}}',
  'help.contact.title': 'Une question ?',
  'help.contact.support': 'Écrire au support',
  'help.contact.admins': 'Écrire à mes administrateurs',
  'common.routing.help': 'Centre d\'aide',
  'tours.dashboard.title': 'Tableau de bord',
  'tours.dashboard.description': 'Où en sont vos apprenants, et ce qui demande une action.',
  'tours.dashboard.summary.title': 'Avancement global',
  'tours.dashboard.summary.body': 'Le taux de modules terminés, le nombre d\'apprenants inscrits à une session, et la répartition complété, incomplet, non commencé, pas encore ouvert, comptée par apprenant et par module.',
  'tours.dashboard.report.title': 'Rapport PDF',
  'tours.dashboard.report.body': 'Téléchargez ces chiffres en PDF, pour un point d\'équipe ou un financeur.',
  'tours.dashboard.trend.title': 'Tendance',
  'tours.dashboard.trend.body': 'Les modules terminés sur 30, 90 ou 180 jours : la dynamique, au-delà de la photo du jour.',
  'tours.dashboard.alerts.title': 'À traiter',
  'tours.dashboard.alerts.body': 'Ce qui appelle une action aujourd\'hui : sessions échues avec des apprenants à relancer, échéances proches, inscrits qui n\'ont jamais commencé, sessions qui démarrent.',
  'tours.dashboard.help.title': 'Centre d\'aide',
  'tours.dashboard.help.body': 'Toujours en haut de l\'écran : les visites guidées de chaque écran, et le formulaire pour poser une question.',
  'tours.modules.title': 'Modules',
  'tours.modules.description': 'Importer vos contenus SCORM et suivre l\'espace qu\'ils occupent.',
  'tours.modules.storage.title': 'Espace de stockage',
  'tours.modules.storage.body': 'L\'espace utilisé par vos modules, face au quota de votre formule.',
  'tours.modules.import.title': 'Importer un module',
  'tours.modules.import.body': 'Donnez un titre au module, choisissez son package ci-dessous, puis cliquez sur « Importer » : il est vérifié, puis rendu disponible pour vos parcours. En cas d\'échec, la raison s\'affiche ici et le fichier reste choisi : cliquez à nouveau sur « Importer » pour réessayer.',
  'tours.modules.dropzone.title': 'Déposer le package',
  'tours.modules.dropzone.body': 'Glissez le .zip ici, ou cliquez pour le choisir. Un fichier qui n\'est pas un zip, ou trop lourd, est refusé tout de suite. Pendant l\'envoi, une barre montre l\'avancement et le temps restant, et « Annuler » l\'interrompt ; vient ensuite l\'extraction et la vérification du module.',
  'tours.modules.search.title': 'Rechercher',
  'tours.modules.search.body': 'Retrouvez un module par son titre, sans vous soucier des accents ni des majuscules.',
  'tours.modules.filters.title': 'Filtrer par statut',
  'tours.modules.filters.body': 'N\'affichez que les modules prêts, ceux encore en traitement, ou ceux dont l\'import a échoué.',
  'tours.modules.list.title': 'Vos modules',
  'tours.modules.list.body': 'Chaque module importé, à prévisualiser tel que l\'apprenant le verra, ou à supprimer. Sous le tableau : « Précédent » et « Suivant » pour changer de page, et le nombre de lignes par page.',
  'tours.sessions.title': 'Sessions',
  'tours.sessions.description': 'Composer des parcours et y inscrire vos apprenants.',
  'tours.sessions.new.title': 'Nouvelle session',
  'tours.sessions.new.body': 'Dépliez si besoin la « Fiche formation » (objectifs, prérequis, public, méthodes, évaluation, accessibilité, contact), que l\'apprenant lira sur l\'écran du parcours ; avec au moins un objectif, cochez « Positionnement obligatoire à l\'entrée » pour que chaque apprenant s\'auto-évalue sur les objectifs avant d\'ouvrir un module. Choisissez les modules du parcours, leurs dates d\'ouverture et, si besoin, le module à terminer avant chacun — avec un score minimum. Regroupez-les en chapitres si besoin (« Commencer un chapitre ici »). Pour chaque module, dites s\'il peut être refait une fois terminé, et quel score compte alors : le meilleur, le dernier ou la moyenne. Choisissez ce qu\'exige l\'attestation : tous les modules terminés, chacun réussi, ou un score minimum sur chacun, puis son modèle — celui par défaut de l\'organisation, ou un autre de ses modèles d\'attestation. Posez-lui des étiquettes libres pour la retrouver (Entrée pour valider chacune). Désignez les formateurs qui l\'animent, parmi les comptes formateur et administrateur que vous voyez. Ajoutez enfin les participants, un par un ou par groupe, et validez avec « Créer ».',
  'tours.sessions.search.title': 'Rechercher',
  'tours.sessions.search.body': 'Retrouvez une session par son nom ou par le titre de l\'un de ses modules, sans vous soucier des accents ni des majuscules.',
  'tours.sessions.filters.title': 'Filtres',
  'tours.sessions.filters.body': 'Restreignez la liste aux sessions actives ou archivées, puis, avec le filtre voisin, à celles dont le parcours contient un module donné, ou — si vous avez accès aux groupes — qui comptent au moins un inscrit d\'un groupe, ou encore, dès qu\'une étiquette existe, qui la portent, ou, dès qu\'un formateur est affecté, qu\'il anime. Les filtres se combinent.',
  'tours.sessions.list.title': 'Vos sessions',
  'tours.sessions.list.body': 'Chaque session avec ses modules, ses formateurs, ses participants et ses étiquettes. Cliquez sur son nom pour ouvrir sa fiche : configuration, parcours, participants et résultats. Sous le tableau : « Précédent » et « Suivant » pour changer de page, et le nombre de lignes par page.',
  'tours.users.title': 'Utilisateurs et apprenants',
  'tours.users.description': 'Retrouver, inviter et exporter les comptes de votre organisation.',
  'tours.users.search.title': 'Rechercher',
  'tours.users.search.body': 'Cherchez par nom, adresse, pseudo, société ou service ; filtrez par groupe ou avancement.',
  'tours.users.add.title': 'Ajouter ou importer',
  'tours.users.add.body': 'Invitez une personne par e-mail, ou créez un apprenant sans e-mail avec « Pseudo et mot de passe » ; importez-en plusieurs depuis un fichier CSV dans l\'un ou l\'autre mode. Société et service sont facultatifs, dans le formulaire comme dans le fichier (colonnes « societe » et « service »). Validez avec « Créer » ou « Importer » : une invitation part par e-mail, ou les identifiants s\'affichent une seule fois, à copier ou à imprimer avec « Télécharger la fiche ».',
  'tours.users.export.title': 'Exporter',
  'tours.users.export.body': 'Récupérez la liste affichée en CSV, filtres compris.',
  'tours.users.table.title': 'La liste',
  'tours.users.table.body': 'La société, le service, le rôle, la dernière connexion et le statut de chacun. Cliquez sur une adresse pour ouvrir la fiche de la personne, cochez des lignes pour les ajouter d\'un coup à un groupe.',
  'tours.groups.title': 'Groupes',
  'tours.groups.description': 'Regrouper vos apprenants pour les inscrire ensemble.',
  'tours.groups.search.title': 'Rechercher',
  'tours.groups.search.body': 'Retrouvez un groupe par son nom ou sa description, sans vous soucier des accents ni des majuscules.',
  'tours.groups.new.title': 'Nouveau groupe',
  'tours.groups.new.body': 'Un groupe réunit des apprenants — une équipe, un site, une promotion — pour les inscrire à une session en un clic. Nommez-le, cochez ses membres, puis « Créer ».',
  'tours.groups.list.title': 'Vos groupes',
  'tours.groups.list.body': 'Chaque groupe et son nombre de membres, à modifier ou supprimer depuis le menu de la ligne. Sous le tableau : « Précédent » et « Suivant » pour changer de page, et le nombre de lignes par page.',
  'tours.certificates.title': 'Attestations',
  'tours.certificates.description': 'Gérer les modèles d\'attestation remis en fin de parcours.',
  'tours.certificates.template.title': 'Le modèle',
  'tours.certificates.template.body': 'Le nom du modèle, tel qu\'il apparaît dans le choix du parcours, puis le texte, le logo et le fond de l\'attestation. Les variables entre accolades se remplissent pour chaque apprenant.',
  'tours.certificates.preview.title': 'Aperçu',
  'tours.certificates.preview.body': 'Générez une attestation d\'exemple pour vérifier le rendu avant d\'enregistrer.',
  'tours.reminders.title': 'Rappels e-mail',
  'tours.surveyEditor.title': 'Questionnaire de satisfaction',
  'tours.surveyEditor.description': 'Les questions posées aux apprenants avant leur attestation.',
  'tours.surveyEditor.intro.title': 'Le principe',
  'tours.surveyEditor.intro.body': 'Le questionnaire est proposé à chaque apprenant qui a terminé un parcours, juste avant son attestation. Il peut le passer : l\'attestation reste téléchargeable. Les résultats, sans nom, se lisent dans la fiche de chaque session.',
  'tours.surveyEditor.questions.title': 'Les questions',
  'tours.surveyEditor.questions.body': 'Pour chacune : son libellé, et une note de 1 à 5 ou un texte libre. Une seule question notée est la « satisfaction globale » : c\'est elle qui fait le taux de satisfaction. Les flèches changent l\'ordre, la corbeille supprime.',
  'tours.surveyEditor.add.title': 'Ajouter',
  'tours.surveyEditor.add.body': 'Ajoute une question en bas de la liste, 15 au plus.',
  'tours.surveyEditor.save.title': 'Enregistrer',
  'tours.surveyEditor.save.body': 'Rien ne change pour les apprenants avant d\'avoir cliqué ici. Les réponses déjà données gardent les libellés qu\'elles ont lus.',
  'tours.documents.title': 'Documents',
  'tours.documents.description': 'Les documents remis aux apprenants, et la preuve qu\'ils les ont reçus.',
  'tours.documents.intro.title': 'La remise des documents',
  'tours.documents.intro.body': 'Qualiopi demande de montrer que chaque stagiaire a reçu le règlement intérieur, le programme et les conditions de la formation (indicateur 9). Les documents déposés ici apparaissent sur l\'écran du parcours de l\'apprenant, qui déclare en avoir pris connaissance.',
  'tours.documents.new.title': 'Ajouter un document',
  'tours.documents.new.body': '« Ajouter un document » : choisissez un PDF de 10 Mo au plus, donnez-lui un titre, choisissez son parcours ou « Tous les parcours », cochez « À accepter avant de commencer » s\'il le faut, puis « Déposer le document ». Un document à accepter ferme les modules de l\'apprenant tant qu\'il ne l\'a pas lu, sauf s\'il a déjà commencé.',
  'tours.documents.list.title': 'Suivre la remise',
  'tours.documents.list.body': 'Chaque ligne dit pour quel parcours vaut le document et combien d\'apprenants l\'ont lu ; ce nombre ouvre la liste des accusés de lecture, avec leur date, à exporter en CSV. Les icônes téléchargent le document, modifient ses réglages (puis « Enregistrer ») ou l\'archivent : les apprenants ne le voient plus, ses accusés restent.',
  'tours.quality.title': 'Amélioration continue',
  'tours.quality.description': 'Le journal des actions d\'amélioration et le registre des risques qualité.',
  'tours.quality.intro.title': 'La boucle d\'amélioration',
  'tours.quality.intro.body': 'Qualiopi demande de montrer ce que vous faites des retours (indicateur 32) et, depuis la V10, d\'analyser les risques sur la qualité de vos prestations. Seuls les administrateurs voient cet écran : il reprend réclamations et abandons.',
  'tours.quality.tabs.title': 'Deux registres',
  'tours.quality.tabs.body': '« Actions d\'amélioration » : ce qui est décidé à partir d\'un retour, et son effet. « Risques qualité » : ce qui pourrait dégrader vos formations, classé du plus grave au moins grave.',
  'tours.quality.export.title': 'Exporter',
  'tours.quality.export.body': 'Télécharge en CSV le registre affiché, avec toutes ses colonnes : ce que l\'auditeur demande.',
  'tours.quality.new.title': 'Ajouter',
  'tours.quality.new.body': 'Une action : choisissez son origine, décrivez le constat et la décision, le responsable et l\'échéance, puis « Enregistrer l\'action ». Un risque : décrivez-le, cotez sa probabilité et son impact de 1 à 3, la mesure qui le maîtrise, puis « Enregistrer le risque ».',
  'tours.quality.list.title': 'Suivre',
  'tours.quality.list.body': '« Ouvrir » sur une ligne : faites avancer l\'état, notez l\'effet mesuré d\'une action (la date de réalisation se note toute seule), ou revoyez la cote d\'un risque, puis « Enregistrer ». Rien ne se supprime : une action abandonnée ou un risque clos restent pour l\'audit.',
  'tours.accommodations.title': 'Accueil handicap',
  'tours.accommodations.description': 'Le référent handicap et les besoins d\'aménagement des apprenants.',
  'tours.accommodations.intro.title': 'L\'accueil des personnes en situation de handicap',
  'tours.accommodations.intro.body': 'Qualiopi demande un référent identifié et la prise en compte des besoins d\'aménagement (indicateur 26). Ces besoins sont des données de santé : seuls les administrateurs les voient, jamais les formateurs.',
  'tours.accommodations.referent.title': 'Le référent',
  'tours.accommodations.referent.body': 'Saisissez le nom et le contact de votre référent handicap, puis « Enregistrer ». Ils s\'affichent sur la page « Mon compte » de chaque apprenant, à côté de sa demande.',
  'tours.accommodations.list.title': 'Les demandes',
  'tours.accommodations.list.body': 'Chaque apprenant peut décrire ce dont il a besoin, après avoir donné son consentement. « Traiter » ouvre la demande : écrivez ce qui est mis en place, cochez « Demande traitée », puis « Enregistrer ». L\'apprenant lit votre réponse ; s\'il modifie sa demande, elle repasse à traiter. S\'il la retire, elle disparaît.',
  'tours.complaints.title': 'Réclamations',
  'tours.complaints.description': 'Le registre des demandes, réclamations et signalements, et leur traitement.',
  'tours.complaints.intro.title': 'Le registre',
  'tours.complaints.intro.body': 'Chaque demande envoyée par un apprenant depuis son centre d\'aide y entre, avec la nature qu\'il a choisie. Seuls les administrateurs le voient : un signalement de violence, de harcèlement ou de discrimination ne doit jamais atteindre un formateur. C\'est la trace que Qualiopi demande (indicateurs 31 et 12).',
  'tours.complaints.filters.title': 'Filtrer',
  'tours.complaints.filters.body': 'Par état (ouverte, en cours, résolue) et par nature. Les signalements sont en rouge dans la liste.',
  'tours.complaints.export.title': 'Exporter',
  'tours.complaints.export.body': 'Télécharge en CSV les entrées affichées, filtres compris, avec les dates de réception, de réponse et de résolution : ce que l\'auditeur demande.',
  'tours.complaints.new.title': 'Saisir une réclamation',
  'tours.complaints.new.body': 'Pour une réclamation reçue autrement (courrier, téléphone, entretien) : choisissez sa nature, saisissez l\'objet et le message, puis « Enregistrer la réclamation ».',
  'tours.complaints.list.title': 'Traiter',
  'tours.complaints.list.body': '« Traiter » ouvre l\'entrée : relisez le message, corrigez sa nature, changez son état, rédigez la réponse apportée, puis « Enregistrer ». La date de la première réponse et celle de la résolution sont notées toutes seules. La réponse n\'est pas envoyée à l\'apprenant : répondez-lui par vos canaux habituels.',
  'tours.reminders.description': 'Relancer automatiquement les apprenants qui n\'ont pas terminé.',
  'tours.reminders.cadence.title': 'Cadence des rappels',
  'tours.reminders.cadence.body': 'Activez les rappels, puis réglez le délai avant le premier envoi, l\'intervalle entre deux rappels (3 jours minimum), leur nombre maximum (1 à 10) et l\'heure d\'envoi. Seuls les apprenants d\'un parcours actif qui n\'ont pas terminé sont relancés.',
  'tours.reminders.message.title': 'Message envoyé',
  'tours.reminders.message.body': 'L\'objet et le corps du rappel. Les variables listées sous le message (prénom, nom du module, lien…) sont remplacées pour chaque apprenant.',
  'tours.reminders.digest.title': 'Récapitulatif des parcours terminés',
  'tours.reminders.digest.body': 'Indépendant des rappels : cochez la case pour que tous les administrateurs reçoivent chaque matin vers 7 h la liste des parcours terminés depuis le précédent récapitulatif, avec le nom de chaque apprenant.',
  'tours.reminders.convocation.title': 'Convocation à l\'inscription',
  'tours.reminders.convocation.body': 'Activée par défaut : chaque apprenant inscrit à un parcours reçoit un e-mail avec le nom du parcours, ses dates, sa durée estimée et le lien pour y accéder. La date d\'envoi est gardée, et s\'exporte dans les rapports (colonne « Convoqué le ») : c\'est votre preuve d\'information pour Qualiopi. Décochez puis enregistrez pour ne plus l\'envoyer.',
  'tours.reminders.test.title': 'M\'envoyer un test',
  'tours.reminders.test.body': 'Vous envoie, à vous seul, le message tel qu\'il est à l\'écran — même pas encore enregistré — pour vérifier son rendu.',
  'tours.reminders.save.title': 'Enregistrer',
  'tours.reminders.save.body': 'Rien ne s\'applique avant l\'enregistrement, récapitulatif compris. Les rappels partent ensuite une fois par jour au plus, à l\'heure d\'envoi choisie et au rythme réglé plus haut.',
  'tours.sso.title': 'Authentification SSO',
  'tours.sso.description': 'Laisser vos utilisateurs se connecter avec le compte de leur entreprise.',
  'tours.sso.intro.title': 'Le SSO',
  'tours.sso.intro.body': 'Vos utilisateurs se connectent avec le compte de leur entreprise : Entra ID, Google Workspace, Okta, OpenID Connect ou SAML.',
  'tours.sso.master.title': 'Interrupteur général',
  'tours.sso.master.body': 'Allume ou coupe la connexion par SSO pour toute l\'organisation. Il s\'applique tout de suite, sans enregistrer. Coupé, aucun bouton SSO n\'apparaît sur l\'écran de connexion, mais les configurations restent en place.',
  'tours.sso.picker.title': 'Fournisseur à configurer',
  'tours.sso.picker.body': 'Choisissez le fournisseur dont vous voulez afficher la fiche. Ce choix n\'enregistre rien ; la ligne du dessous rappelle les fournisseurs déjà configurés.',
  'tours.sso.provider.title': 'Fiche du fournisseur',
  'tours.sso.provider.body': 'Son activation, le libellé de son bouton de connexion, les identifiants fournis par votre fournisseur (le secret n\'est plus jamais réaffiché) et les domaines e-mail autorisés. Une fois enregistrée, la fiche affiche l\'adresse de retour à déclarer chez le fournisseur ; « Supprimer » efface la configuration et son secret.',
  'tours.sso.save.title': 'Enregistrer',
  'tours.sso.save.body': 'Chaque fournisseur s\'enregistre avec son propre bouton. Pour l\'activer, ses champs obligatoires doivent être remplis — et, pour Google ou un Entra ouvert à plusieurs organisations, au moins un domaine.',
  'tours.billing.title': 'Facturation',
  'tours.billing.description': 'Suivre ce que coûte votre formule et souscrire un palier.',
  'tours.billing.month.title': 'Mois observé',
  'tours.billing.month.body': 'Un apprenant est compté une seule fois par année contractuelle, et la facturation ne bloque jamais aucune session. Le mois choisi ici change seulement l\'estimation affichée.',
  'tours.billing.estimate.title': 'L\'estimation du mois',
  'tours.billing.estimate.body': 'Le montant du mois, les apprenants décomptés et les places restantes de votre palier, les actifs du mois et ceux qui sortent du décompte dans les 3 prochains mois.',
  'tours.billing.plan.title': 'Votre palier',
  'tours.billing.plan.body': 'Avant de souscrire : les quatre paliers, chacun avec sa capacité d\'apprenants et son prix hors taxes. Une fois abonné, cette carte affiche votre palier, sa prochaine échéance et, s\'il y en a un, le changement programmé (descente de palier, passage au mois) ou la date de fin d\'un abonnement résilié. Si Studeva gère votre formule, elle le dit : il n\'y a alors rien à choisir.',
  'tours.billing.term.title': 'Au mois ou au comptant',
  'tours.billing.term.body': 'Au mois, sans engagement ; au comptant, l\'année réglée d\'avance avec deux mois offerts. Les prix des offres suivent ce choix.',
  'tours.billing.subscribe.title': 'Souscrire',
  'tours.billing.subscribe.body': '« Souscrire » ouvre la page de paiement sécurisée de Stripe : adresse, numéro de TVA, carte et acceptation des CGV. Votre palier s\'active dès que Stripe confirme le paiement, en général en quelques secondes.',
  'tours.billing.manage.title': 'Gérer mon abonnement',
  'tours.billing.manage.body': 'Ouvre l\'espace sécurisé de Stripe : changer de palier (une montée s\'applique tout de suite, au prorata ; une descente ou un passage au mois, à l\'échéance), résilier à l\'échéance, changer de carte, télécharger vos factures. Vos changements s\'affichent ici en quelques secondes.',
  'tours.billing.profile.title': 'Coordonnées de facturation',
  'tours.billing.profile.body': 'Raison sociale, numéro de TVA, adresse et e-mail de facturation, avec leur propre bouton « Enregistrer ». Après une première souscription, ils se gèrent dans l\'espace sécurisé de Stripe, avec vos factures.',
  'tours.billing.history.title': 'Historique',
  'tours.billing.history.body': 'Les 12 derniers mois, recalculés avec votre formule actuelle. Lecture seule.',
  'tours.billingPlatform.title': 'Facturation plateforme',
  'tours.billingPlatform.description': 'Lire ce que chaque organisation consomme et rapporte.',
  'tours.billingPlatform.month.title': 'Mois observé',
  'tours.billingPlatform.month.body': 'Choisissez le mois à lire. Tout l\'écran se lit : rien n\'y est modifiable, rien à enregistrer.',
  'tours.billingPlatform.counters.title': 'Décompte par organisation',
  'tours.billingPlatform.counters.body': 'Pour chaque organisation : apprenants décomptés, actifs du mois, apprenants enregistrés, formule et revenu estimé — avec le total en bas.',
  'tours.billingPlatform.storage.title': 'Stockage par organisation',
  'tours.billingPlatform.storage.body': 'L\'espace utilisé, le plafond de la formule et le nombre de modules ; un badge signale les organisations au-delà de leur plafond.',
  'tours.organizations.title': 'Organisations',
  'tours.organizations.description': 'Créer les organisations clientes et gérer leurs membres.',
  'tours.organizations.create.title': 'Créer une organisation',
  'tours.organizations.create.body': 'Ouvre un formulaire : nom, identifiant d\'URL (minuscules, chiffres et tirets) et administrateur. L\'organisation n\'existe qu\'une fois le formulaire validé par « Créer » ; l\'administrateur reçoit alors un e-mail d\'invitation.',
  'tours.organizations.list.title': 'Les organisations',
  'tours.organizations.list.body': 'Chaque organisation, avec son identifiant d\'URL, son nombre de membres, sa formule et son statut : activée ou suspendue.',
  'tours.organizations.actions.title': 'Actions',
  'tours.organizations.actions.body': '« Modifier » change le nom, l\'identifiant (un renommage casse les liens déjà partagés, d\'où une confirmation), le statut ou la formule — mode de facturation (abonnement, ou géré par Studeva avec sa note interne) et palier —, à enregistrer. « Membres » invite, change un rôle (tout de suite), ouvre la session d\'un membre ou le retire — ce qui supprime son compte. « Suspendre » et « Activer » s\'appliquent immédiatement. « Supprimer » n\'est possible que sur une organisation vide.',
  'tours.trialRequests.title': 'Demandes d\'essai',
  'tours.trialRequests.description': 'Ouvrir ou refuser l\'espace des organismes qui ont demandé un essai.',
  'tours.trialRequests.intro.title': 'Demandes en attente',
  'tours.trialRequests.intro.body': 'Les organismes qui ont confirmé leur adresse e-mail et attendent la création de leur espace.',
  'tours.trialRequests.list.title': 'La liste',
  'tours.trialRequests.list.body': 'Pour chaque demande : l\'organisme, le demandeur et ses coordonnées, sa fonction et la date de confirmation.',
  'tours.trialRequests.actions.title': 'Approuver ou refuser',
  'tours.trialRequests.actions.body': '« Approuver » crée tout de suite l\'espace, sur la formule gratuite, et envoie l\'e-mail d\'activation — sans confirmation. « Refuser » demande un motif facultatif, inclus dans l\'e-mail envoyé au demandeur.',
  'helpDemo.banner': 'Démonstration : données fictives, rien n\'est enregistré.',
  'helpDemo.back': 'Retour au centre d\'aide',
  'helpDemo.inert': 'Dans la démonstration, rien ne se lance.',
  'helpDemo.player.placeholder': 'Le contenu du module s\'affiche ici, en plein écran.',
  'helpDemo.session.group': 'Agence Nord',
  'helpDemo.session.survey.question': 'Dans l\'ensemble, êtes-vous satisfait·e de cette formation ?',
  'helpDemo.session.survey.module': 'Les gestes qui sauvent',
  'helpDemo.session.survey.commentLabel': 'Qu\'est-ce qui pourrait être amélioré ?',
  'helpDemo.session.survey.comment': 'Plus de mises en situation, s\'il vous plaît.',
  'helpDemo.session.tag': 'Promo d\'automne',
  'helpDemo.path.name': 'Accueil des nouveaux arrivants',
  'sheet.title': 'Fiche formation',
  'sheet.help': 'Ce que l\'apprenant doit savoir avant et pendant la formation. Tout est facultatif ; ce qui est rempli s\'affiche sur l\'écran du parcours. Les objectifs peuvent aussi figurer sur l\'attestation avec la variable {{objectives}}.',
  'sheet.objectives': 'Objectifs',
  'sheet.objectives.help': 'Un objectif par ligne, {{count}} au plus.',
  'sheet.prerequisites': 'Prérequis',
  'sheet.audience': 'Public visé',
  'sheet.teachingMethods': 'Modalités et méthodes pédagogiques',
  'sheet.assessmentMethods': 'Modalités d\'évaluation',
  'sheet.accessibility': 'Accessibilité',
  'sheet.contact': 'Contact',
  'sheet.positioning': 'Positionnement obligatoire à l\'entrée',
  'sheet.positioning.help': 'Avant d\'ouvrir un module, chaque apprenant s\'auto-évalue sur les objectifs ci-dessus et dit ses attentes. Il pourra se réévaluer en fin de parcours. Un apprenant qui a déjà commencé n\'est pas bloqué.',
  'sheet.positioning.needsObjectives': 'Saisissez au moins un objectif pour demander un positionnement.',
  'path.sheet.title': 'À propos de cette formation',
  'helpDemo.path.sheet.objective1': 'Connaître les règles de sécurité du site',
  'helpDemo.path.sheet.objective2': 'Savoir à qui s\'adresser la première semaine',
  'helpDemo.path.sheet.audience': 'Salariés arrivés depuis moins d\'un mois',
  'helpDemo.path.sheet.prerequisites': 'Aucun',
  'helpDemo.path.sheet.contact': 'formation@exemple.fr',
  'helpDemo.path.basics': 'Les bases',
  'helpDemo.path.further': 'Aller plus loin',
  'helpDemo.path.welcome.title': 'Bienvenue',
  'helpDemo.path.welcome.description': 'Présentation de l\'organisme et de votre parcours.',
  'helpDemo.path.essentials.title': 'Les gestes essentiels',
  'helpDemo.path.essentials.description': 'Les réflexes à connaître dès le premier jour.',
  'helpDemo.path.cases.title': 'Cas pratiques',
  'helpDemo.path.cases.description': 'Des situations réelles, pour s\'entraîner.',
  'helpDemo.path.assessment.title': 'Évaluation finale',
  'helpDemo.path.assessment.description': 'Un questionnaire pour valider le parcours.',
  'tours.path.title': 'L\'écran d\'un parcours',
  'tours.path.description': 'Suivre ses étapes, savoir pourquoi l\'une est fermée — sur un parcours de démonstration.',
  'tours.path.header.title': 'Le parcours',
  'tours.path.header.body': 'Son nom, son état (à commencer, en cours, terminé), votre avancement (étapes terminées, temps restant estimé), la façon d\'avancer — dans l\'ordre imposé, ou librement — et la date à laquelle il vous a été assigné. « Mes formations », au-dessus, ramène à l\'accueil. Une fois le parcours terminé — et la condition de l\'attestation remplie, s\'il en pose une — l\'attestation se télécharge ici ; sinon, l\'écran dit ce qu\'il manque.',
  'tours.path.sheet.title': 'À propos de cette formation',
  'tours.path.sheet.body': 'Cliquez pour déplier ce que l\'organisme a décrit de la formation : ses objectifs, ses prérequis, le public visé, les méthodes, l\'évaluation, l\'accessibilité et le contact. Le bloc n\'apparaît que s\'il a été rempli.',
  'tours.path.documents.title': 'Les documents',
  'tours.path.documents.body': 'Le règlement, le programme ou le livret que l\'organisme vous remet : « Télécharger » pour les lire, puis « J\'ai pris connaissance ». Ceux marqués « À lire avant de commencer » ferment les modules jusqu\'à ce que vous l\'ayez fait.',
  'tours.path.positioning.title': 'Le positionnement',
  'tours.path.positioning.body': 'Si la formation le demande, positionnez-vous avant de commencer : « Me positionner », notez-vous de 1 à 5 sur chaque objectif, dites vos attentes si vous le souhaitez, puis « Envoyer ». Les modules s\'ouvrent ensuite. À la fin du parcours, « Me réévaluer » vous propose de mesurer vos progrès, sans obligation.',
  'tours.path.steps.title': 'Les étapes',
  'tours.path.steps.body': 'Toutes les étapes, groupées par chapitre avec leur avancement. Chacune dit où elle en est : terminée (avec score et temps passé), en cours, ou fermée — avec la raison : une date à attendre, ou un module à terminer ou réussir. « C\'est parti », « Reprendre » ou « Recommencer » ouvre le module ; « Recommencer » n\'apparaît que si le parcours permet de le refaire.',
  'tours.path.focus.title': 'L\'étape à suivre',
  'tours.path.focus.body': 'Le module à reprendre maintenant : sa durée, son seuil de réussite, votre score, et le bouton pour le reprendre. Si aucune étape n\'est ouverte, le panneau dit pourquoi ; parcours terminé, il le dit aussi. Votre progression s\'enregistre d\'elle-même pendant que vous suivez le module : rien à enregistrer.',
  'tours.player.title': 'Le lecteur de module',
  'tours.player.description': 'Suivre un module, en sortir, reprendre plus tard — sur une démonstration.',
  'tours.player.exit.title': 'Sortir',
  'tours.player.exit.body': 'Revient à « Mes formations » à tout moment. Votre progression est conservée : vous reprendrez là où vous en étiez.',
  'tours.player.header.title': 'Où vous en êtes',
  'tours.player.header.body': 'Le parcours suivi et, s\'il compte plusieurs modules, le rang de celui-ci (« Étape 2 sur 4 »).',
  'tours.player.content.title': 'Le module',
  'tours.player.content.body': 'Le module s\'affiche ici. Votre progression s\'enregistre d\'elle-même pendant que vous avancez : rien à enregistrer. À la fin d\'un chapitre, un écran propose le suivant ; à la fin du module, il le confirme, et un bouton vous ramène à « Mes formations ».',
  'tours.preview.title': 'Prévisualiser un module',
  'tours.preview.description': 'Jouer un module comme un apprenant, sans rien enregistrer — sur une démonstration.',
  'tours.preview.exit.title': 'Retour aux modules',
  'tours.preview.exit.body': 'Revient à la liste des modules, d\'où s\'ouvre la prévisualisation.',
  'tours.preview.header.title': 'Prévisualisation',
  'tours.preview.header.body': 'Le module joué, marqué « Prévisualisation » : rien de ce que vous y faites n\'est enregistré, ni progression ni score.',
  'tours.preview.content.title': 'Le module',
  'tours.preview.content.body': 'Le module se joue ici exactement comme pour un apprenant, sans inscription ni suivi. Rien à enregistrer.',
  'tours.webhooks.title': 'Webhooks',
  'tours.webhooks.description': 'Prévenir votre système quand un apprenant termine un module ou un parcours.',
  'tours.webhooks.intro.title': 'Les webhooks',
  'tours.webhooks.intro.body': 'À chaque module terminé, et à chaque parcours terminé, Studeva envoie un appel à votre système avec l\'apprenant, le parcours, le module et son résultat.',
  'tours.webhooks.endpoint.title': 'La destination',
  'tours.webhooks.endpoint.body': 'L\'adresse HTTPS de votre système, joignable depuis Internet, et l\'interrupteur des envois. Coupé, il n\'ajoute plus rien à la file ; les appels déjà en attente échouent et sont rejoués selon le calendrier — ils repartent si vous le rallumez à temps, et sont abandonnés au bout d\'environ 31 h.',
  'tours.webhooks.save.title': 'Enregistrer',
  'tours.webhooks.save.body': 'Rien ne s\'applique avant l\'enregistrement. Le premier enregistrement génère le secret de signature, affiché une seule fois.',
  'tours.webhooks.secret.title': 'Le secret',
  'tours.webhooks.secret.body': 'Il signe chaque appel ; votre système recalcule la signature pour s\'assurer qu\'il vient de Studeva. Copiez-le dès qu\'il s\'affiche. « Remplacer le secret » en génère un nouveau, et l\'ancien cesse aussitôt de signer.',
  'tours.webhooks.deliveries.title': 'Derniers envois',
  'tours.webhooks.deliveries.body': 'Chaque appel, son statut, sa dernière réponse et, s\'il attend, son prochain essai. Un appel refusé est rejoué au bout d\'1 min, 10 min, 1 h, 6 h puis 24 h, et abandonné ensuite. Le bouton de rafraîchissement relit le journal.',
  'tours.webhooks.test.title': 'Envoyer un test',
  'tours.webhooks.test.body': 'Met en file un appel de test vers la destination active, pour vérifier qu\'elle répond et que la signature se vérifie. Il part dès que possible.',
  'tours.trainerCapabilities.title': 'Droits du formateur',
  'tours.trainerCapabilities.description': 'Choisir ce que les formateurs peuvent faire dans votre organisation.',
  'tours.trainerCapabilities.intro.title': 'Le rôle Formateur',
  'tours.trainerCapabilities.intro.body': 'Ces réglages valent pour tous les formateurs de l\'organisation. Les administrateurs ne sont jamais limités : vous ne pouvez pas vous retirer vos propres droits.',
  'tours.trainerCapabilities.domains.title': 'Les droits, par domaine',
  'tours.trainerCapabilities.domains.body': 'Cochez ce que le formateur peut faire sur les parcours, les modules, les apprenants et les statistiques. Un droit en suppose parfois d\'autres : les cocher ensemble est automatique, et décocher un droit retire ceux qui en dépendent. Un droit retiré masque aussi le menu et les boutons correspondants. Seul le rapport PDF est bloqué par le serveur : l\'export CSV, masqué, reprend des données déjà affichées.',
  'tours.trainerCapabilities.save.title': 'Enregistrer',
  'tours.trainerCapabilities.save.body': 'Rien ne change avant l\'enregistrement. Ensuite, l\'accès est refusé dès la prochaine action du formateur ; son écran se met à jour à son prochain chargement.',
  'tours.branding.title': 'Personnalisation',
  'tours.branding.description': 'Mettre l\'application aux couleurs de votre organisation.',
  'tours.branding.identity.title': 'Identité',
  'tours.branding.identity.body': 'Le nom de l\'application, vos logos pour fond clair et fond sombre, et le favicon.',
  'tours.branding.colors.title': 'Couleurs',
  'tours.branding.colors.body': 'La couleur principale habille la navigation et les boutons ; son encre doit rester lisible (contraste d\'au moins 4,5:1), sinon l\'enregistrement est refusé. Videz une encre pour qu\'elle soit calculée.',
  'tours.branding.save.title': 'Enregistrer',
  'tours.branding.save.body': 'Vos réglages s\'appliquent à toute l\'organisation dès l\'enregistrement.',
  'tours.dashboard.tiles.title': 'Indicateurs clés',
  'tours.dashboard.tiles.body': 'Taux de réussite, moyenne des résultats et temps moyen passé, sur l\'ensemble de vos apprenants.',
  'tours.dashboard.range.title': 'Période',
  'tours.dashboard.range.body': 'Choisissez de regarder les 30, 90 ou 180 derniers jours.',
  'tours.modules.actions.title': 'Aperçu, remplacement, renommage et suppression',
  'tours.modules.actions.body': 'Le bouton lecture ouvre le module tel que l\'apprenant le verra, sans compter comme une tentative. Les flèches remplacent son contenu par une nouvelle version du zip : vous voyez d\'abord ce que ça change (parcours, apprenants terminés ou en cours), puis vous confirmez avec « Remplacer le contenu » ; le suivi des apprenants est conservé. Le crayon le renomme : saisissez le nouveau titre, puis « Enregistrer ». La corbeille le supprime, après confirmation : ses fichiers partent avec lui.',
  'tours.sessions.trainers.title': 'Formateurs',
  'tours.sessions.trainers.body': 'Qui anime chaque session. Les formateurs se choisissent dans le formulaire de la session, parmi les comptes formateur et administrateur que vous voyez, et s\'enregistrent avec elle (« Créer » ou « Enregistrer »). L\'affectation est indicative : elle ne change pas ce que chacun peut voir ou faire.',
  'tours.sessions.status.title': 'Statut',
  'tours.sessions.status.body': 'Une session active est ouverte à ses participants ; archivée — depuis sa modification —, elle sort de leur accueil sans perdre leurs résultats.',
  'tours.sessions.actions.title': 'Actions',
  'tours.sessions.actions.body': 'Modifier le parcours, les dates, les conditions d\'ouverture, les règles pour refaire un module, le modèle d\'attestation, les formateurs et les participants — pensez à « Enregistrer » —, la dupliquer pour un nouveau groupe — la copie reprend tout sauf les dates et les apprenants, à choisir puis enregistrer —, prévisualiser son premier module, ou supprimer la session — une confirmation annonce combien d\'apprenants perdent leur suivi.',
  'tours.users.filters.title': 'Filtres',
  'tours.users.filters.body': 'Restreignez la liste à un groupe, ou à un état d\'avancement : non commencé, en cours, terminé.',
  'tours.users.select.title': 'Sélection',
  'tours.users.select.body': 'Cochez des lignes, ou toute la page, pour ajouter ou retirer plusieurs personnes d\'un groupe en une fois.',
  'tours.users.actions.title': 'Actions sur un compte',
  'tours.users.actions.body': 'Voir les sessions de la personne ; pour l\'admin, modifier le compte — puis valider avec « Modifier » —, le supprimer, « Renvoyer l\'email de validation » à un compte encore en attente, s\'y connecter à sa place pour l\'aider, ou, pour un apprenant en pseudo, « Réinitialiser le mot de passe » et lui remettre le nouveau.',
  'tours.groups.actions.title': 'Actions',
  'tours.groups.actions.body': 'Modifier le nom et les membres d\'un groupe — puis « Enregistrer » —, ou le supprimer : ses membres gardent leur compte et leurs inscriptions.',
  'tours.certificates.variables.title': 'Variables',
  'tours.certificates.variables.body': 'Ces mots entre accolades sont remplacés par le nom de l\'apprenant, la formation, la date ou le score au moment de générer l\'attestation.',
  'tours.certificates.logo.title': 'Logo',
  'tours.certificates.logo.body': 'Le logo imprimé sur l\'attestation, s\'il doit différer de celui de l\'application.',
  'tours.certificates.background.title': 'Fond',
  'tours.certificates.background.body': 'Un PDF d\'une page, à votre charte, sur lequel le texte vient s\'imprimer.',
  'tours.certificates.email.title': 'Prévenir l\'apprenant',
  'tours.certificates.email.body': 'Cochez la case pour que l\'apprenant des parcours qui utilisent ce modèle reçoive un e-mail, avec le lien vers son parcours, dès que son attestation est disponible. Pensez à enregistrer.',
  'tours.certificates.save.title': 'Enregistrer',
  'tours.certificates.save.body': 'Rien ne s\'applique avant l\'enregistrement. Les attestations sont générées à chaque téléchargement : le modèle enregistré s\'applique aussi à celles des parcours déjà terminés qui l\'utilisent.',
  'tours.branding.misc.title': 'Divers',
  'tours.branding.misc.body': 'Le texte du pied de page et la langue proposée par défaut à vos utilisateurs.',
  'tours.account.title': 'Mon compte',
  'tours.account.description': 'Vos informations, votre mot de passe et vos préférences.',
  'tours.account.profile.title': 'Votre profil',
  'tours.account.profile.body': 'Votre adresse, votre rôle, votre organisation et votre dernière connexion. L\'adresse ne se modifie pas ici.',
  'tours.account.identity.title': 'Prénom et nom',
  'tours.account.identity.body': 'Corrigez-les puis cliquez sur « Enregistrer » : ils sont repris partout, attestations comprises.',
  'tours.account.password.title': 'Mot de passe',
  'tours.account.password.body': 'Saisissez l\'actuel, puis le nouveau deux fois, et validez avec « Changer le mot de passe ». L\'œil de chaque champ affiche ce que vous tapez. Vos autres appareils sont déconnectés.',
  'tours.account.preferences.title': 'Préférences',
  'tours.account.preferences.body': 'La langue et le thème s\'appliquent dès le clic, sans rien à enregistrer, sur cet appareil.',
  'tours.account.accommodation.title': 'Besoin d\'un aménagement',
  'tours.account.accommodation.body': 'Si vous avez besoin d\'une adaptation pour suivre vos formations, décrivez-la ici, cochez la case de consentement, puis « Envoyer ma demande ». Seuls les administrateurs de votre organisme la lisent. Vous y voyez aussi votre référent handicap et la réponse de l\'organisme ; « Modifier » ou « Retirer ma demande » à tout moment.',
  'tours.home.title': 'Mon espace de formation',
  'tours.home.description': 'Retrouver vos formations et savoir par où reprendre.',
  'tours.home.dashboard.title': 'Tableau de bord',
  'tours.home.dashboard.body': 'Revenez ici à tout moment, depuis n\'importe quel écran de votre espace : vos formations, votre avancement et par où reprendre.',
  'tours.home.search.title': 'Rechercher',
  'tours.home.search.body': 'Retrouvez une formation ou un module par son nom, sans vous soucier des accents. Raccourci : Ctrl K (⌘ K sur Mac) ; les flèches parcourent les résultats, Entrée ouvre le résultat choisi.',
  'tours.home.hero.title': 'Votre avancement',
  'tours.home.hero.body': 'Combien de formations vous avez terminées, et par laquelle reprendre : le bouton vous y emmène directement.',
  'tours.home.paths.title': 'Vos parcours',
  'tours.home.paths.body': 'Un parcours enchaîne plusieurs modules, parfois regroupés en chapitres. Ouvrez-le pour voir ses étapes, leur durée, votre score et l\'avancement de chaque chapitre. Une fois tout terminé, le bouton « Attestation » apparaît sur la carte — ou, si le parcours exige une réussite ou un score, ce qu\'il manque encore.',
  'tours.home.courses.title': 'Vos formations',
  'tours.home.courses.body': 'Une formation d\'un seul module se lance directement depuis sa carte. Une fois terminée, « Recommencer » la relance pour une nouvelle tentative, si votre formateur le permet. Le bouton « Attestation » apparaît quand elle est obtenue ; sinon, la carte dit ce qu\'il manque.',
  'tours.home.menu.title': 'Votre compte',
  'tours.home.menu.body': 'Votre compte, vos préférences et le centre d\'aide : les visites guidées de votre espace, et le formulaire pour nous écrire. Vous y retrouvez aussi les conditions d\'utilisation et la politique de confidentialité.',
  'status.disabled': 'Désactivé',
  'common.lastConnection': 'Dernière connexion',
  'status.active': 'Activé',
  'status.pending': 'En attente',
  'common.search': 'Recherche',
  'common.add': 'Ajouter',
  'common.export': 'Exporter',
  'common.refresh': 'Actualiser',
  'export.truncated': 'Export limité aux {{max}} premières lignes sur {{total}} : affinez les filtres pour tout obtenir.',
  'common.status': 'Statut',
  'common.action': 'Actions',
  'common.update': 'Modifier',
  'common.delete': 'Supprimer',
  'common.impersonate': 'Consulter son espace',
  'common.previous': 'Précédent',
  'common.next': 'Suivant',
  'good.update.user': 'La modification de l\'utilisateur a été réalisée avec succès.',
  'bad.update.user': 'La modification de l\'utilisateur a échoué.',
  'update.user': 'Modifier un utilisateur',
  'input.required.message': 'Ce champ est requis',
  'input.email.message': 'Entrez votre adresse email !',
  'common.cancel': 'Annuler',
  'good.delete.user': 'La suppression de l\'utilisateur a été réalisée avec succès.',
  'bad.delete.user': 'La suppression de l\'utilisateur a échoué.',
  'delete.user': 'Supprimer un utilisateur',
  'delete.user.first-message': 'Supprimer cet utilisateur supprimera toutes ses statistiques et accès.',
  'delete.second-message': 'Êtes-vous sûr ?',
  'good.add.user': 'L\'ajout de l\'utilisateur a été réalisé avec succès.',
  'bad.add.user': 'L\'ajout de l\'utilisateur a échoué.',
  'demo.learnerLimit': 'Votre espace de démonstration compte déjà 10 apprenants, son maximum. Pour en ajouter, désactivez un compte apprenant ou passez à une formule payante.',
  'add.user.emailUsed': 'Cette adresse email est déjà utilisée par un compte.',
  'create.user': 'Créer un utilisateur',
  'common.create': 'Créer',
  'common.home': 'Accueil',
  'common.mechanics': 'Mécaniques',
  'quiz.result.title': 'Résultat du quiz',
  'quiz.result.questions': 'Réponses correctes',
  'quiz.result.failure': 'Échec',
  'quiz.result.success': 'Réussite',
  'quiz.restart': 'Recommencer',
  'time.left': 'Temps restant',
  'quiz.question': 'Question',
  'quiz.answer.correct': 'Bonne réponse !',
  'quiz.answer.incorrect': 'Mauvaise réponse !',
  'common.validate': 'Valider',
  'common.finish': 'Terminer',
  'messages-history': 'Historique des messages',
  'no.history.infos': 'Aucun message',
  'reset.password.success': 'Un e-mail de réinitialisation a été envoyé',
  'bad.reset.message': 'L\'email de réinitialisation n\'a pas pu être envoyé.',
  'bad.server-login.message': 'Impossible de contacter le serveur !',
  'common.loading': 'Chargement',
  'reset.password': 'Réinitialiser votre mot de passe',
  'common.submit': 'Envoyer',
  'login.return-message': 'Retour à la page de connexion',
  'input.password': 'Entrez votre mot de passe !',
  'password.not-match.message': 'Les mots de passe ne correspondent pas',
  'new.password.success': 'Votre mot de passe a été mis à jour',
  'new.password': 'Nouveau mot de passe',
  'new.password.description': 'Entrez votre nouveau mot de passe',
  'common.password': 'Mot de passe',
  'common.confirm-password': 'Confirmer le mot de passe',
  'logout.pending': 'Déconnexion en cours',
  'login.microsoft': 'Connexion avec Microsoft',
  'impossible.read.token': 'Impossible de lire le token !',
  'connection.successful': 'Connexion réussie !',
  'connection.failed': 'La connexion a échoué !',
  'common.login': 'Connexion',
  'password.forgot': 'Mot de passe oublié ?',
  'login.identifier': 'Adresse email ou pseudo',
  'login.identifier.placeholder': 'vous@exemple.com ou pseudo',
  'login.username.forgot': 'Connexion par pseudo ? Demandez un nouveau mot de passe à votre établissement.',
  'password.show': 'Afficher le mot de passe',
  'common.register': 'Je me crée un compte',
  'access.denied.message': 'Vous n\'avez pas les droits d\'accès à cette page.',
  'input.password-confirm': 'Confirmez votre mot de passe',
  'good.register.message': 'L\'inscription a été réalisée avec succès.',
  'bad.register.message': 'L\'inscription a échoué.',
  'finish.register': 'Création de compte',
  'password.confirm': 'Confirmez votre mot de passe',
  'good-order.message': 'L\'ordre correct est :',
  'reset.password.description': 'Entrez votre adresse e-mail pour réinitialiser votre mot de passe',
  'common.login.description': 'Entrez votre email et votre mot de passe ci-dessous pour vous connecter à votre compte',
  'common.or': 'ou',
  'login.tagline': 'Apprenez.\nProgressez.\nCertifiez-vous.',
  'login.tagline.sub': 'Vos formations, votre progression et vos attestations, réunies en un seul endroit.',
  'login.magic-link.cta': 'Recevoir un lien de connexion',
  'login.magic-link.description': 'Entrez votre email : nous vous envoyons un lien de connexion, sans mot de passe.',
  'login.magic-link.submit': 'Envoyer le lien',
  'login.magic-link.sent.title': 'Vérifiez votre boîte mail',
  'login.magic-link.sent.description': 'Si un compte est associé à {{email}}, un lien de connexion vient d\'y être envoyé. Il expire dans 15 minutes et ne fonctionne qu\'une seule fois.',
  'login.magic-link.resend': 'Renvoyer le lien',
  'login.password.cta': 'Se connecter avec un mot de passe',
  'magic-link.checking': 'Connexion en cours',
  'magic-link.checking.description': 'Nous vérifions votre lien de connexion.',
  'magic-link.failed.title': 'Lien invalide ou expiré',
  'magic-link.failed.description': 'Ce lien a déjà été utilisé ou a expiré. Demandez-en un nouveau depuis la page de connexion.',
  'magic-link.request-new': 'Demander un nouveau lien',
  'finish.register.message': 'Bonjour {{firstName}} {{lastName}}, choisissez le mot de passe du compte {{email}} pour l\'activer.',
  'invitation.expired': 'Invitation expirée',
  'invitation.expired.message': 'Ce lien d\'invitation a expiré. Demandez une nouvelle invitation à l\'administrateur de votre espace.',
  'invitation.invalid': 'Invitation invalide',
  'invitation.invalid.message': 'Ce lien d\'invitation est invalide ou a déjà été utilisé. Si votre compte est déjà actif, connectez-vous.',
  'good.reset.message': 'L\'email de réinitialisation a bien été envoyé.',
  'create.account': 'Créer un compte',
  'create.account.description': 'Entrez vos informations pour créer un compte',
  'create.account.success': 'Votre compte a été créé avec succès',
  'first.name': 'Prénom',
  'last.name': 'Nom',
  'new.password.message': 'Entrez votre adresse email et votre nouveau mot de passe',
  'common.ok': 'Valider',
  'common.game-mechanics': 'Mécaniques de jeu',
  'quiz-mechanisms.available': 'Mécaniques disponibles',
  'common.welcome': 'Bienvenue',
  'no.content': 'Aucun contenu',
  'common.confirm': 'Confirmer',
  'common.noResults': 'Aucun résultat avec ces filtres.',
  'common.noResultsFor': 'Aucun résultat pour « {{query}} ».',
  'common.allStatuses': 'Tous les statuts',
  'common.reset': 'Réinitialiser',
  'common.empty': 'Aucune donnée',
  'desc.sort': 'Cliquez pour trier par ordre décroissant',
  'asc.sort': 'Cliquez pour trier par ordre croissant',
  'cancel.sort': 'Cliquez pour annuler le tri',
  'your.informations': 'Vos informations',
  'you.are': 'Vous êtes',
  'your.email': 'Votre email',
  'token.creation.message': 'Votre session a été créée le :',
  'token.expiration.message': 'Votre session expirera le :',
  'common.hello': 'Bonjour',
  'user.management': 'Gestion des utilisateurs',
  'add.user': 'Ajouter un utilisateur',
  'bad.connection': 'Connexion impossible',
  'bad.connection.message': 'Le mot de passe et l’email saisis ne correspondent pas. Veuillez vérifier vos informations et vous connecter à nouveau.',
  'access.refused.accountDisabled': 'Votre compte est désactivé. Contactez l’administrateur de votre organisation.',
  'access.refused.organizationSuspended': 'L’accès à votre organisation est suspendu. Contactez l’administrateur de votre organisation.',
  'common.more': 'Plus',
  'common.breadcrumb': 'Fil d\'Ariane',
  'sidebar.toggle': 'Afficher ou masquer le menu',
  'sidebar.mobile.title': 'Menu',
  'sidebar.mobile.description': 'Navigation du back-office.',
  'common.close': 'Fermer',
  'common.quiz-mechanics': 'Mécaniques de quiz',
  'import.user': 'Importer un utilisateur',
  'good.import.user': 'L\'import de l\'utilisateur a été réalisé avec succès.',
  'bad.import.user': 'L\'import de l\'utilisateur a échoué.',
  'bad.import.user.none': 'Aucun compte n\'a été créé : toutes les lignes ont été refusées.',
  'warn.import.user.partial': 'Import partiel : {{count}} ligne(s) refusée(s).',
  'download.template': 'Télécharger le modèle',
  'click.to.upload': 'Cliquez pour importer',
  'common.import': 'Importer',
  'import.csv.help': 'Fichier CSV avec les colonnes {{headers}} (séparateur point-virgule). Les apprenants reçoivent un email d\'invitation.',
  'import.csv.groupHelp': 'Colonne « groupe » facultative : le groupe est créé s\'il n\'existe pas encore.',
  'import.csv.parsed': '{{count}} ligne(s) détectée(s) dans « {{file}} ».',
  'import.preview.valid': '{{count}} ligne(s) prête(s) à être importée(s).',
  'import.preview.none': 'Aucune ligne importable dans ce fichier.',
  'import.preview.skipped': '{{count}} ligne(s) seront ignorées :',
  'import.preview.checking': 'Vérification des adresses déjà utilisées…',
  'import.check.failed': 'Impossible de vérifier les adresses déjà utilisées : elles seront contrôlées à l\'import.',
  'import.submit': 'Importer {{count}} ligne(s)',
  'import.report.created': '{{count}} compte(s) créé(s) et invité(s) par email.',
  'import.report.partial': '{{count}} compte(s) créé(s) et invité(s) par email, {{failed}} ligne(s) refusée(s).',
  'import.report.none': 'Aucun compte créé : les {{count}} ligne(s) du fichier ont été refusées.',
  'import.report.line': 'Ligne',
  'import.report.reason': 'Motif',
  'import.error.empty': 'Le fichier CSV est vide.',
  'import.error.badHeader': 'En-têtes invalides. Attendu : email ; firstName ; lastName.',
  'import.error.MISSING_FIELDS': 'Champ obligatoire manquant',
  'import.error.INVALID_EMAIL': 'Email invalide',
  'import.error.DEMO_LEARNER_LIMIT': 'Démo pleine : 10 apprenants au maximum',
  'import.error.DUPLICATE_IN_FILE': 'Doublon dans le fichier',
  'import.error.EMAIL_ALREADY_USED': 'Email déjà utilisé',
  'import.error.CREATION_FAILED': 'Échec de la création',
  'common.settings': 'Personnalisation',
  'unknow.error': 'Erreur inconnue !',
  'common.dashboard': 'Tableau de bord',
  'dashboard.noStatistics': 'Votre organisation ne vous donne pas accès aux statistiques.',
  'dashboard.subtitle': 'Ce qui appelle une action, puis où en sont vos apprenants.',
  'dashboard.alerts.title': 'À traiter',
  'impersonate.user': 'Consulter l\'espace de {{name}}',
  'bad.impersonate.user': 'Impossible d\'ouvrir l\'espace de cet utilisateur.',
  'impersonate.user.preview': 'Vous verrez l\'application exactement telle que {{name}} la voit : ses sessions, ses modules, sa progression. Sa propre session reste ouverte de son côté, et les modules que vous ouvrez ne sont pas enregistrés pour lui.',
  'impersonate.user.not-read-only': 'Ce n\'est pas un mode lecture seule : en dehors de la progression SCORM, toute action effectuée depuis son espace sera réellement exécutée et enregistrée à son nom.',
  'impersonate.user.return-hint': 'Un bandeau en haut de l\'écran vous permettra de revenir à votre compte à tout moment.',
  'impersonate.user.confirm': 'Ouvrir son espace',
  'impersonate.started': 'Vous consultez maintenant l\'espace de {{name}}',
  'impersonate.banner.message': 'Vous consultez l\'espace de {{name}}',
  'impersonate.banner.warning': 'Sa progression n\'est pas enregistrée, mais vos autres actions le sont.',
  'impersonate.banner.exit': 'Revenir à mon compte',
  'impersonate.exit.failed': 'Impossible de restaurer votre session admin. Veuillez vous reconnecter.',
  'account.validate': 'Validation de compte',
  'account.validate.confirmation': 'Veuillez confirmer votre compte en cliquant sur le bouton ci-dessous',
  'valid.account.success': 'Votre compte a été validé avec succès !',
  'valid.account.failed': 'La validation de votre compte a échoué. Veuillez réessayer plus tard.',
  'resend.email.success': 'Email de validation envoyé avec succès',
  'resend.email.failed': 'Échec de l\'envoi de l\'email de validation',
  'resend.email': 'Renvoyer l\'email de validation',
  'scorm.player.title': 'Module SCORM',
  'scorm.player.loading': 'Chargement du module...',
  'scorm.player.error': 'Erreur lors du chargement du module SCORM',
  'scorm.progress.saved': 'Progression sauvegardée',
  'scorm.progress.save.error': 'Erreur lors de la sauvegarde de la progression',
  'common.statistics': 'Statistiques',
  'common.completionStatus': 'Statut de complétion',
  'common.successStatus': 'Statut de réussite',
  'common.score': 'Score',
  'common.completedAt': 'Date de complétion',
  'common.totalTime': 'Temps total',
  'status.completed': 'Complété',
  'status.archived': 'Archivée',
  'sessions.name': 'Session',
  'user.sessions.title': 'Sessions de l\'utilisateur',
  'user.sessions.subtitle': 'Sessions et progression de {{name}}',
  'user.sessions.empty': 'Cet utilisateur n\'est inscrit à aucune session.',
  'user.sessions.progress': 'Progression',
  'user.sessions.view': 'Voir les sessions',
  'user.lastConnection.never': 'Jamais',
  'user.progress.label': 'Avancement',
  'user.progress.all': 'Tous les avancements',
  'user.progress.notStarted': 'Jamais commencé',
  'user.progress.inProgress': 'En cours',
  'user.progress.completed': 'Terminé',
  'status.incomplete': 'Incomplet',
  'status.not_attempted': 'Non commencé',
  'status.unknown': 'Inconnu',
  'status.passed': 'Réussi',
  'status.failed': 'Échoué',
  'login.sso': 'Connexion SSO',
  'login.sso.with': 'Continuer avec {{provider}}',
  'sso.error': 'Erreur de connexion SSO',

  // Navigation & communs
  'common.modules': 'Modules',
  'common.module': 'Module',
  'common.sessions': 'Sessions',
  'common.session': 'Session',
  'common.allSessions': 'Toutes les sessions',
  'common.name': 'Nom',
  'common.organizations': 'Organisations',
  'billing.title': 'Facturation',
  'billing.help': 'Un apprenant est compté une seule fois par année contractuelle, dès sa première connexion. Les comptes admin ne comptent jamais. Ce compteur observe : il ne bloque aucune session, jamais.',
  'billing.month': 'Mois observé',
  'billing.monthlyActive': 'Actifs du mois',
  'billing.yearlyActive': 'Apprenants formés',
  'billing.registered': 'Apprenants enregistrés',
  'billing.freeTier': 'Plan gratuit',
  'billing.freeTier.within': 'Inclus ({{learners}}/{{limit}})',
  'billing.freeTier.over': 'Au-delà du gratuit',
  'billing.devis.over': 'Au-delà de {{threshold}} apprenants : parlons-nous',
  'billing.total': 'Total',
  'billing.empty': 'Aucune organisation.',
  'billing.neverBlocked': 'Votre palier fixe le prix. Dépasser sa capacité ne bloque aucun apprenant : vous êtes invité à en changer.',
  'billing.amountDue': 'Montant du mois',
  'billing.amountDue.free': 'Inclus dans le plan gratuit ({{limit}} apprenants formés par an).',
  'billing.amountDue.overFree': 'Au-delà du plan gratuit, rien n\'est facturé tant qu\'aucune formule n\'est choisie : à ce rythme, l\'année coûterait {{amount}}.',
  'billing.amountDue.upfront': 'Année réglée d\'avance ({{amount}}) : le mois ne doit rien.',
  'billing.amountDue.monthly': 'Le prix du palier, réglé au mois. Résiliable à tout moment.',
  'billing.managed.title': 'Formule gérée par Studeva',
  'billing.managed.body': 'Votre formule est convenue directement avec Studeva : il n\'y a ni palier à choisir ni paiement en ligne, aucun plafond d\'apprenants et toutes les fonctionnalités sont ouvertes. Pour la faire évoluer, contactez votre interlocuteur Studeva.',
  'billing.managed.hint': 'Ni plafond ni restriction : votre formule est gérée par Studeva.',
  'billing.plan.title': 'Votre palier',
  'billing.offers.title': 'Choisir un palier',
  'billing.offers.capacity': 'Jusqu\'à {{count}} apprenants',
  'billing.offers.perMonth': 'HT / mois',
  'billing.offers.perYear': 'HT / an',
  'billing.offers.subscribe': 'Souscrire',
  'billing.offers.subscribeTo': 'Souscrire au palier {{tier}}',
  'billing.offers.redirecting': 'Ouverture du paiement…',
  'billing.offers.note': 'TVA en sus. Le paiement se fait sur la page sécurisée de Stripe ; votre palier s\'active dès que le paiement est confirmé.',
  'billing.offers.error': 'La page de paiement n\'a pas pu s\'ouvrir. Réessayez dans un instant.',
  'billing.offers.error.subscribed': 'Un abonnement est déjà en cours pour votre organisation. Rechargez la page pour le voir.',
  'billing.offers.error.impersonation': 'Seul un administrateur de l\'organisation, connecté avec son propre compte, peut souscrire.',
  'billing.offers.error.unavailable': 'Le paiement en ligne est momentanément indisponible. Écrivez-nous à contact@studeva.fr.',
  'billing.checkout.pending.title': 'Paiement en cours de confirmation',
  'billing.checkout.pending.body': 'Stripe nous confirme votre paiement : votre palier s\'active dans quelques secondes. Vous pouvez rester sur cette page.',
  'billing.checkout.confirmed.title': 'Votre abonnement est actif',
  'billing.checkout.confirmed.body': 'Votre palier est en place. Retrouvez vos factures auprès de Stripe, par e-mail.',
  'billing.checkout.slow.title': 'La confirmation prend plus de temps que prévu',
  'billing.checkout.slow.body': 'Votre paiement est en cours de traitement par Stripe. Rechargez la page dans quelques minutes ; si votre palier n\'apparaît toujours pas, écrivez-nous à contact@studeva.fr.',
  'billing.checkout.canceled.title': 'Paiement annulé',
  'billing.checkout.canceled.body': 'Aucun paiement n\'a été prélevé. Vous pouvez souscrire quand vous le souhaitez.',
  'billing.subscription.current': 'Palier {{tier}} · {{term}}',
  'billing.subscription.renews': 'Prochaine échéance le {{date}}.',
  'billing.subscription.cancels': 'Abonnement résilié : votre palier reste actif jusqu\'au {{date}}, puis l\'espace repasse en mode démo.',
  'billing.subscription.scheduled': 'Le {{date}}, passage au palier {{tier}} ({{term}}).',
  'billing.paymentFailed': 'Le dernier paiement de votre abonnement a échoué. Stripe va réessayer dans les prochains jours : mettez à jour votre carte pour garder votre palier. Sans paiement, votre espace repassera en mode démo.',
  'billing.paymentFailed.update': 'Mettre à jour ma carte',
  'billing.portal.manage': 'Gérer mon abonnement',
  'billing.portal.invoices': 'Factures et coordonnées',
  'billing.portal.opening': 'Ouverture…',
  'billing.portal.profile': 'Vos coordonnées de facturation (adresse, n° de TVA, e-mail) se gèrent avec vos factures, dans l\'espace sécurisé de Stripe.',
  'billing.offers.error.noCustomer': 'Aucun abonnement n\'a encore été souscrit : il n\'y a rien à gérer pour l\'instant.',
  'billing.offers.error.managed': 'Votre formule est gérée par Studeva : écrivez-nous à contact@studeva.fr pour vos factures et coordonnées.',
  'billing.mode.SELF_SERVICE': 'Abonnement souscrit par l\'organisation',
  'billing.mode.MANAGED': 'Géré par Studeva',
  'billing.mode.SELF_SERVICE.help': 'L\'organisation choisit et règle elle-même son palier.',
  'billing.mode.MANAGED.help': 'Hors abonnement : ni plafond d\'apprenants ni fonctionnalité bloquée, et rien ne le retire tout seul. Pour les clients migrés, le sur devis et les partenaires.',
  'billing.tier.FREE': 'Démo',
  'billing.tier.S': 'S',
  'billing.tier.M': 'M',
  'billing.tier.L': 'L',
  'billing.tier.XL': 'XL',
  'billing.tier.CUSTOM': 'Géré par Studeva',
  'billing.tier.FREE.help': 'Mode démo : toutes les fonctionnalités, jusqu\'à 10 apprenants.',
  'billing.tier.S.help': 'Jusqu\'à 50 apprenants — 99 €/mois, 990 €/an.',
  'billing.tier.M.help': 'Jusqu\'à 100 apprenants — 189 €/mois, 1 890 €/an.',
  'billing.tier.L.help': 'Jusqu\'à 250 apprenants — 449 €/mois, 4 490 €/an.',
  'billing.tier.XL.help': 'Jusqu\'à 500 apprenants — 849 €/mois, 8 490 €/an.',
  'billing.tier.CUSTOM.help': 'Au-delà de 500 apprenants : sur devis.',
  'billing.tier.CUSTOM.notice': 'Au-delà de 500 apprenants, le tarif se fait sur devis — contactez-nous.',
  'billing.term.field': 'Règlement',
  'billing.term.UPFRONT': 'Au comptant',
  'billing.term.MONTHLY': 'Au mois',
  'billing.term.UPFRONT.help': 'L\'année réglée d\'avance : deux mois offerts (10 mois payés pour 12). Non remboursable.',
  'billing.term.MONTHLY.help': 'Résiliable à tout moment ; la facturation s\'arrête à la fin du mois en cours. Sans engagement.',
  'billing.learnerCount': 'Apprenants décomptés',
  'billing.billedTier': 'Palier {{tier}}',
  'billing.placesRemaining': 'Palier {{tier}} — encore {{places}} places incluses',
  'billing.overCapacity': 'Vos {{learners}} apprenants dépassent la capacité du palier {{tier}} : passez au palier {{needed}}. Rien n\'est bloqué en attendant.',
  'billing.overCapacity.quote': 'Vos {{learners}} apprenants dépassent la capacité du palier {{tier}} et du dernier palier : contactez-nous pour un devis. Rien n\'est bloqué en attendant.',
  'billing.overCapacityShort': 'Au-delà : {{needed}}',
  'billing.quote': 'Sur devis',
  'billing.capacityAlert.change': 'Changer de palier',
  'billing.capacityAlert.contact': 'Nous contacter pour changer de palier',
  'billing.placesShort': '{{places}} places incluses',
  'billing.leavingSoon': 'Sortants à 3 mois',
  'billing.leavingSoon.help': 'Apprenants qui quitteront le compteur d\'ici 3 mois s\'ils ne sont ni réinscrits ni revenus.',
  'billing.yearly.base': 'Socle de l\'année',
  'billing.yearly.commitmentAmount': 'Année engagée',
  'billing.yearly.tolerated': 'Apprenants couverts',
  'billing.yearly.overage': 'Régularisation estimée',
  'billing.yearly.overage.monthly': 'Sans objet : vos apprenants sont facturés au fil des mois.',
  'billing.yearly.estimate': 'À ce rythme, l\'année contractuelle coûtera {{amount}}.',
  'billing.profile.title': 'Coordonnées de facturation',
  'billing.profile.help': 'Reprises telles quelles sur vos factures. Un champ laissé vide n\'empêche rien.',
  'billing.profile.companyName': 'Raison sociale',
  'billing.profile.vatNumber': 'N° de TVA intracommunautaire',
  'billing.profile.addressLine1': 'Adresse',
  'billing.profile.addressLine2': 'Complément d\'adresse',
  'billing.profile.postalCode': 'Code postal',
  'billing.profile.city': 'Ville',
  'billing.profile.country': 'Pays',
  'billing.profile.billingEmail': 'Email de facturation',
  'billing.profile.saved': 'Coordonnées enregistrées.',
  'billing.profile.error': 'Coordonnées non enregistrées.',
  'billing.history.title': 'Historique',
  'billing.history.help': 'Douze derniers mois. Les montants sont recalculés avec votre formule actuelle : les factures réelles arriveront avec le règlement en ligne.',
  'billing.history.month': 'Mois',
  'billing.history.counted': 'Entrées au compteur',
  'billing.history.amount': 'Montant',
  'billing.plan': 'Formule',
  'billing.estimatedRevenue': 'Revenu estimé',
  // Stockage (#180) : mesuré partout, plafonné sur le seul plan gratuit.
  'storage.title': 'Stockage',
  'storage.size': 'Taille',
  'storage.used': 'Utilisé',
  'storage.quota': 'Plafond',
  'storage.usedOfQuota': '{{used}} / {{quota}}',
  'storage.remaining': 'Il vous reste {{remaining}}.',
  'storage.moduleCount': '{{count}} module(s)',
  'storage.noQuota': 'Votre formule n\'impose aucun plafond de stockage.',
  'storage.overQuota': 'Vous avez dépassé le stockage inclus dans le plan gratuit. Vos modules restent accessibles à vos apprenants ; seuls les nouveaux imports sont refusés le temps de faire de la place ou de choisir une formule payante.',
  'storage.overQuota.badge': 'Au-delà du plafond',
  'storage.uploadRefused': 'Import refusé faute de place : vous occupez {{used}} sur les {{quota}} du plan gratuit, et ce module en demande {{incoming}} de plus. Supprimez un module devenu inutile, ou passez à une formule payante pour lever le plafond.',
  'storage.platform.title': 'Stockage par organisation',
  'storage.platform.help': 'Ce que la plateforme héberge réellement. Le plafond ne s\'applique qu\'aux organisations au plan gratuit : ailleurs, on mesure sans rien refuser.',
  'organization.create': 'Créer une organisation',
  'organization.create.help': 'L\'administrateur reçoit un email d\'invitation pour finaliser son compte.',
  'organization.slug': 'Identifiant (URL)',
  'organization.members': 'Membres',
  'organization.suspended': 'Suspendue',
  'organization.suspend': 'Suspendre',
  'organization.activate': 'Activer',
  'organization.admin.email': 'Email de l\'administrateur',
  'organization.edit.title': 'Modifier l\'organisation',
  'organization.edit.required': 'Le nom et l\'identifiant sont requis.',
  'organization.edit.success': 'Organisation mise à jour.',
  'organization.edit.failed': 'Mise à jour échouée (identifiant déjà utilisé ou invalide ?).',
  'organization.edit.planFailed': 'Organisation enregistrée, mais la formule n\'a pas pu être changée.',
  'organization.edit.planSubscribed': 'Organisation enregistrée, mais son palier est payé sur Stripe : seul son admin peut le changer, depuis « Gérer mon abonnement ».',
  'organization.edit.slug.help': 'Changer l\'identifiant modifie l\'URL de connexion de l\'organisation.',
  'organization.edit.billingMode': 'Mode de facturation',
  'organization.edit.billingNote': 'Note interne',
  'organization.edit.billingNote.help': 'Contrat, mode de règlement… Visible de Studeva seulement, jamais de l\'organisation.',
  'organization.edit.tier': 'Formule',
  'organization.delete.title': 'Supprimer l\'organisation',
  'organization.delete.confirm': 'Confirmer la suppression de « {{name}} » ? Cette action est irréversible.',
  'organization.delete.success': 'Organisation supprimée.',
  'organization.delete.failed': 'Suppression échouée.',
  'organization.delete.notEmpty': 'Retirez d\'abord tous les membres : une organisation non vide ne peut pas être supprimée.',
  'organization.delete.default': 'L\'organisation par défaut ne peut pas être supprimée.',
  'organization.members.title': 'Membres — {{name}}',
  'organization.members.empty': 'Aucun membre.',
  'organization.member.invite.title': 'Inviter un membre',
  'organization.member.invite.required': 'Email, prénom et nom sont requis.',
  'organization.member.invite.submit': 'Inviter',
  'organization.member.invite.success': 'Invitation envoyée.',
  'organization.member.invite.failed': 'Invitation échouée.',
  'organization.member.invite.emailUsed': 'Cet email est déjà utilisé.',
  'organization.member.role.success': 'Rôle mis à jour.',
  'organization.member.role.failed': 'Changement de rôle échoué.',
  'organization.member.role.lastAdmin': 'Impossible : c\'est le dernier administrateur de l\'organisation.',
  'organization.member.role.hint': 'Le changement prend effet pour la personne à sa prochaine connexion.',
  'organization.member.impersonate': 'Ouvrir sa session',
  'organization.member.impersonate.hint': 'Ouvre le back-office de cette organisation sous son identité. Toute action y sera réellement exécutée en son nom.',
  'organization.member.remove': 'Retirer',
  'organization.member.remove.success': 'Membre retiré.',
  'organization.member.remove.failed': 'Retrait échoué.',
  'good.add.organization': 'L\'organisation a été créée et son administrateur invité.',
  'bad.add.organization': 'La création de l\'organisation a échoué.',
  'common.title': 'Titre',
  'common.version': 'Version',
  'common.save': 'Enregistrer',
  'common.remove': 'Retirer',
  'common.choose': 'Choisir…',
  'common.participants': 'Participants',

  // White-label / branding
  'branding.identity': 'Identité de l\'application',
  'branding.appName': 'Nom de l\'application',
  'branding.logo': 'Logo',
  'branding.noLogo': 'Aucun logo',
  'branding.favicon': 'Favicon',
  'branding.noFavicon': 'Aucun favicon',
  'branding.colorsTypography': 'Couleurs & typographie',
  'branding.primaryColor': 'Couleur primaire',
  'branding.accentColor': 'Couleur secondaire',
  'branding.accentColor.hint': 'Fonds de survol, lignes actives, badges. Saisissez celle de votre charte.',
  'branding.primaryForeground': 'Texte sur la couleur principale',
  'branding.accentForeground': 'Texte sur la couleur secondaire',
  'branding.foreground.hint': 'Laissez vide pour utiliser automatiquement l\'encre la plus lisible.',
  'branding.suggest': 'Encre lisible',
  'branding.accent.fromPrimary': 'Dériver de la principale',
  'branding.logo.light': 'Logo pour fond clair',
  'branding.logo.dark': 'Logo pour fond sombre',
  'branding.logo.darkHint': 'La version sombre est facultative : sans elle, le logo clair s\'affiche sur les deux thèmes. Ajoutez-la si votre logo est monochrome, sans quoi il disparaîtra pour les apprenants en thème sombre.',
  'branding.contrast.title': 'Contraste des couleurs choisies',
  'branding.contrast.text': 'texte {{ratio}}:1',
  'branding.contrast.textOk': 'lisible',
  'branding.contrast.textFail': 'texte illisible, l\'enregistrement sera refusé',
  'branding.contrast.surface': 'fond {{ratio}}:1',
  'branding.contrast.surfaceOk': 'se détache de la page',
  'branding.contrast.surfaceFail': 'se confond avec la page',
  'branding.contrast.invalid': '{{label}} : couleur non reconnue',
  'branding.preview': 'Aperçu',
  'branding.preview.button': 'Bouton principal',
  'branding.preview.hover': 'Ligne survolée',
  'branding.starter': 'Suggestions :',
  'branding.logo.constraints': 'PNG ou JPEG, {{max}} Ko maximum par fichier.',
  'branding.favicon.constraints': 'PNG, SVG ou ICO, {{max}} Ko maximum. Carré, lisible à 32 pixels.',
  'branding.typography.fixed': 'La typographie est celle de la plateforme et ne se personnalise pas : une police choisie librement n\'est pas forcément disponible sur le poste de vos apprenants.',
  'branding.misc': 'Divers',
  'branding.footerText': 'Texte du pied de page',
  'branding.footerPlaceholder': 'Laisser vide pour un pied de page par défaut',
  'branding.defaultLocale': 'Langue par défaut',
  'branding.imageTooLarge': 'Image trop volumineuse (max {{max}} Ko).',
  'branding.assetTooLarge': '{{asset}} trop volumineux (max {{max}} Ko) : remplacez-le par une image plus légère pour enregistrer.',
  'branding.readError': 'Impossible de lire le fichier.',
  'branding.saved': 'Configuration enregistrée.',
  'branding.saveError': 'Échec de l\'enregistrement.',
  'branding.inkTooLow': '{{color}} : le texte posé dessus est illisible (contraste sous 4,5:1). Choisissez une autre encre, ou videz-la pour qu\'elle soit calculée.',

  // Modules SCORM
  'modules.import.title': 'Importer un module SCORM',
  'modules.package': 'Package (.zip)',
  'modules.list.title': 'Modules',
  'modules.empty': 'Aucun module. Importez un package SCORM.',
  'modules.titlePlaceholder': 'Nom du module',
  'modules.status.ready': 'Prêt',
  'modules.status.processing': 'Traitement…',
  'modules.status.failed': 'Échec',
  'modules.selectFile': 'Sélectionnez un fichier .zip SCORM.',
  'modules.uploadFailed': 'Import échoué',
  'modules.imported': 'Module importé.',
  'modules.upload.hint': 'Package SCORM au format .zip, {{max}} maximum',
  'modules.upload.hintNoMax': 'Package SCORM au format .zip',
  'modules.upload.processing': 'Extraction et vérification du module…',
  'modules.upload.tooLarge': 'Ce package dépasse le poids maximal accepté à l\'import.',
  'modules.upload.network': 'La connexion a été interrompue pendant l\'envoi. Vérifiez votre réseau, puis cliquez à nouveau sur « Importer ».',
  'modules.upload.cancelled': 'Envoi annulé.',
  'modules.refreshFailed': 'La liste des modules n\'a pas pu être rafraîchie. Rechargez la page pour la mettre à jour.',
  'fileDrop.prompt': 'Glissez un fichier ici, ou cliquez pour le choisir',
  'fileDrop.selected': '{{name}} ({{size}})',
  'fileDrop.rejected.count': 'Un seul fichier à la fois.',
  'fileDrop.rejected.type': 'Ce fichier n\'est pas au bon format : {{extensions}} attendu.',
  'fileDrop.rejected.size': 'Ce fichier pèse {{size}}, au-delà du maximum de {{max}}.',
  'upload.sending': 'Envoi… {{percent}} %',
  'upload.progress': 'Progression de l\'envoi',
  'upload.bytes': '{{loaded}} sur {{total}}',
  'upload.remaining.seconds': 'environ {{count}} s restantes',
  'upload.remaining.minutes': 'environ {{count}} min restantes',
  'upload.announce.uploading': 'Envoi du fichier en cours.',
  'modules.deleted': 'Module supprimé.',
  'modules.deleteFailed': 'Suppression échouée.',
  'modules.deleteTitle': 'Supprimer le module « {{name}} » ?',
  'modules.deleteBody': 'Ses fichiers sont effacés avec lui : rien ne se récupère. Un module utilisé par un parcours ne peut pas être supprimé.',
  'modules.inUse': 'Ce module est utilisé par {{sessions}}. Retirez-le de ces parcours avant de le supprimer.',
  'modules.inUseUnnamed': 'Ce module est utilisé par au moins un parcours. Retirez-le de ses parcours avant de le supprimer.',
  'modules.preview': 'Prévisualiser',
  'modules.replace.action': 'Remplacer le contenu',
  'modules.replace.title': 'Remplacer le contenu de « {{name}} »',
  'modules.replace.intro': 'Déposez la nouvelle version du package (.zip). Le module garde le suivi de vos apprenants, et rien ne change pour eux tant que vous n\'avez pas confirmé.',
  'modules.replace.reviewIntro': 'Voici ce que la nouvelle version change. Confirmez pour la mettre en ligne, ou annulez pour garder l\'actuelle.',
  'modules.replace.upload': 'Envoyer',
  'modules.replace.confirm': 'Remplacer le contenu',
  'modules.replace.done': 'Contenu remplacé. Le suivi des apprenants est conservé.',
  'modules.replace.failed': 'Le remplacement a échoué : l\'ancienne version reste en ligne.',
  'modules.replace.sessions_one': 'Utilisé dans {{count}} parcours : {{names}}.',
  'modules.replace.sessions_other': 'Utilisé dans {{count}} parcours : {{names}}.',
  'modules.replace.noSession': 'Utilisé dans aucun parcours.',
  'modules.replace.completed_one': '{{count}} apprenant a terminé : son résultat et son attestation restent acquis.',
  'modules.replace.completed_other': '{{count}} apprenants ont terminé : leurs résultats et attestations restent acquis.',
  'modules.replace.inProgress_one': '{{count}} apprenant est en cours : il reprendra le module au début, sans perdre son temps ni ses scores.',
  'modules.replace.inProgress_other': '{{count}} apprenants sont en cours : ils reprendront le module au début, sans perdre leur temps ni leurs scores.',
  'modules.replace.notStarted_one': '{{count}} inscrit n\'a pas encore commencé.',
  'modules.replace.notStarted_other': '{{count}} inscrits n\'ont pas encore commencé.',
  'modules.replace.scos': 'Chapitres : {{kept}} gardés, {{added}} ajoutés, {{removed}} retirés.',
  'modules.replace.noScoMatch_one': 'Aucun chapitre de la version actuelle ne se retrouve dans la nouvelle : l\'apprenant en cours repart de zéro sur ce module. Vérifiez qu\'il s\'agit bien du même module.',
  'modules.replace.noScoMatch_other': 'Aucun chapitre de la version actuelle ne se retrouve dans la nouvelle : les {{count}} apprenants en cours repartent de zéro sur ce module. Vérifiez qu\'il s\'agit bien du même module.',
  'modules.contentUpdatedAt': 'Contenu mis à jour le {{date}}',
  'modules.rename.action': 'Renommer',
  'modules.rename.title': 'Renommer le module',
  'modules.rename.body': 'Le nouveau titre s\'affiche partout : parcours, espace apprenant et rapports. Le suivi des apprenants ne change pas.',
  'modules.rename.done': 'Module renommé.',
  'modules.rename.failed': 'Le renommage a échoué.',

  // Sessions (back-office)
  'sessions.create.title': 'Créer une session',
  'sessions.namePlaceholder': 'Nom de la session',
  'sessions.selectModule': '— Choisir un module —',
  'sessionDetail.open': 'Ouvrir la fiche de {{name}}',
  'sessionDetail.edit': 'Modifier',
  'sessionDetail.trainers.empty': 'Aucun formateur affecté à cette session.',
  'sessionDetail.back': 'Retour aux sessions',
  'sessionDetail.notFound': 'Cette session n\'existe pas ou n\'est plus accessible.',
  'sessionDetail.dates.range': 'Du {{start}} au {{end}}',
  'sessionDetail.dates.from': 'À partir du {{start}}',
  'sessionDetail.dates.until': 'Jusqu\'au {{end}}',
  'sessionDetail.dates.none': 'Sans dates de début ni de fin',
  'sessionDetail.tags': 'Étiquettes',
  'sessionDetail.info.title': 'Informations',
  'sessionDetail.info.createdAt': 'Créée le',
  'sessionDetail.info.minScore': 'score minimum {{score}} %',
  'sessionDetail.info.template': 'Modèle d\'attestation',
  'sessionDetail.info.defaultTemplate': 'Modèle par défaut',
  'sessionDetail.info.customTemplate': 'Modèle personnalisé',
  'sessionDetail.kpis.title': 'Indicateurs',
  'sessionDetail.kpis.participants': 'Participants',
  'sessionDetail.path.empty': 'Aucun module dans ce parcours.',
  'sessionDetail.path.prerequisite': 'Ouvert après « {{title}} »',
  'sessionDetail.path.prerequisiteScore': 'Ouvert après « {{title}} » avec au moins {{score}} %',
  'sessionDetail.path.completed': '{{completed}} / {{total}} terminé(s)',
  'sessionDetail.participants.title': 'Participants',
  'sessionDetail.participants.modules': 'Modules terminés',
  'sessionDetail.participants.lastActivity': 'Dernière activité',
  'sessionDetail.participants.actions': 'Actions',
  'sessionDetail.kpis.dropoutRate': 'Taux d\'abandon',
  'sessionDetail.kpis.dropoutMethod': 'Abandons déclarés ÷ inscrits de la session',
  'sessionDetail.dropout.status': 'Abandon',
  'sessionDetail.dropout.declare': 'Déclarer un abandon',
  'sessionDetail.dropout.cancel': 'Annuler l\'abandon',
  'sessionDetail.dropout.title': 'Abandon de {{name}}',
  'sessionDetail.dropout.description': 'L\'apprenant ne recevra plus de rappels et sortira des alertes de retard. Ses résultats restent. Vous pourrez annuler l\'abandon s\'il reprend.',
  'sessionDetail.dropout.reason.label': 'Motif d\'abandon',
  'sessionDetail.dropout.reason.placeholder': 'Choisir un motif',
  'sessionDetail.dropout.reason.personal': 'Raisons personnelles',
  'sessionDetail.dropout.reason.professional': 'Raisons professionnelles',
  'sessionDetail.dropout.reason.health': 'Santé',
  'sessionDetail.dropout.reason.content': 'Contenu de la formation',
  'sessionDetail.dropout.reason.technical': 'Difficultés techniques',
  'sessionDetail.dropout.reason.other': 'Autre',
  'sessionDetail.dropout.note': 'Précision (facultative)',
  'sessionDetail.dropout.confirm': 'Déclarer l\'abandon',
  'sessionDetail.dropout.declared': 'Abandon déclaré',
  'sessionDetail.dropout.cancelled': 'Abandon annulé',
  'sessionDetail.dropout.failed': 'L\'abandon n\'a pas pu être enregistré.',
  'sessionDetail.participants.empty': 'Aucun participant dans cet état.',
  'sessionDetail.exports.csv': 'Résultats (CSV)',
  'sessionDetail.exports.pdf': 'Rapport PDF',
  'sessionDetail.exports.questions': 'Analyse des questions',
  'attendance.single': 'Relevé d\'assiduité',
  'attendance.batch': 'Relevés d\'assiduité',
  'attendance.downloadFor': 'Relevé d\'assiduité de « {{name}} »',
  'attendance.failed': 'Le relevé d\'assiduité n\'a pas pu être généré.',
  'common.routing.sessionDetail': 'Fiche session',
  'sessionDetail.results.loading': 'Chargement des résultats…',
  'sessionDetail.results.failed': 'Impossible de charger les résultats de la session.',
  'sessionDetail.results.retry': 'Réessayer',
  'sessions.startDate': 'Début (optionnel)',
  'sessions.endDate': 'Fin (optionnel)',
  'sessions.noUsers': 'Aucun utilisateur.',
  'sessions.list.title': 'Sessions',
  'sessions.allModules': 'Tous les modules',
  'sessions.empty': 'Aucune session.',
  'sessions.nameRequired': 'Renseignez un nom et un module.',

  // Parcours multi-modules (#139) et déblocage programmé (#182)
  'sessions.path.title': 'Modules du parcours',
  'sessions.path.count_one': '{{count}} module',
  'sessions.path.count_other': '{{count}} modules',
  'sessions.path.empty': 'Aucun module. Ajoutez-en un pour composer le parcours.',
  'sessions.path.add': 'Ajouter',
  'sessions.path.required': 'Un parcours doit contenir au moins un module.',
  'sessions.path.prerequisite': 'Ouvert après',
  'sessions.path.prerequisite.none': 'aucun prérequis',
  'sessions.path.prerequisite.previous': '{{title}} (précédent)',
  'sessions.path.minScore': 'avec un score minimum',
  'sessions.path.minScore.label': 'Score minimum à obtenir sur « {{title}} », en pourcentage',
  'sessions.path.minScore.mastery': '(seuil du module : {{score}} %)',
  'sessions.path.minScore.noMastery': 'Ce module ne déclare pas de seuil de réussite : vérifiez qu\'il remonte bien un score, sinon le module suivant ne s\'ouvrira jamais.',
  'sessions.path.retake.allow': 'Peut être refait une fois terminé',
  'sessions.path.retention': 'Score retenu',
  'sessions.path.retention.BEST': 'meilleur score',
  'sessions.path.retention.LAST': 'dernière tentative',
  'sessions.path.retention.AVERAGE': 'moyenne des tentatives',
  'sessions.path.chapter.label': 'Chapitre {{number}}',
  'sessions.path.chapter.title': 'Titre du chapitre {{number}}',
  'sessions.path.chapter.remove': 'Retirer le chapitre {{number}}',
  'sessions.path.chapter.start': 'Commencer un chapitre ici',
  'sessions.path.chapter.default': 'Nouveau chapitre',
  'sessions.path.chapter.titleRequired': 'Donnez un titre à chaque chapitre.',
  'sessions.path.opensOn': 'Ouvre le',
  'sessions.path.reorder': 'Déplacer {{title}} dans le parcours',
  'sessions.path.remove': 'Retirer {{title}} du parcours',
  'sessions.path.stage.on_one': '{{count}} module à la même date',
  'sessions.path.stage.on_other': '{{count}} modules à la même date',
  'sessions.path.stage.immediate_one': '{{count}} module ouvert dès le début',
  'sessions.path.stage.immediate_other': '{{count}} modules ouverts dès le début',
  'sessions.path.stage.setDate': 'Date d\'ouverture du palier',
  'sessions.path.warn.loop': 'Ce module et son prérequis s\'attendent l\'un l\'autre : aucun ne s\'ouvrirait. Choisissez un autre prérequis.',
  'sessions.path.warn.afterEnd': 'Cette date tombe après la fin du parcours : le module n\'ouvrirait jamais.',
  'sessions.path.warn.beforeStart': 'Cette date précède le début du parcours : le module ouvrira au démarrage.',
  'sessions.path.warn.inProgress_one': 'Ce parcours compte {{count}} inscrit. Modifier ses modules change son avancement : un apprenant qui l\'avait terminé y repassera « en cours » et perdra l\'accès à son attestation.',
  'sessions.path.warn.inProgress_other': 'Ce parcours compte {{count}} inscrits. Modifier ses modules change leur avancement : les apprenants qui l\'avaient terminé y repasseront « en cours » et perdront l\'accès à leur attestation.',
  'sessions.certificate.minScoreRequired': 'Indiquez le score minimum exigé pour l\'attestation.',
  'sessions.certificate.noRetake': 'Un module de ce parcours ne peut pas être refait : un apprenant qui le rate, ou reste sous le seuil, n\'obtiendra jamais l\'attestation.',
  'sessions.tags.label': 'Étiquettes',
  'sessions.tags.placeholder': 'Ajoutez une étiquette, puis Entrée',
  'sessions.tags.remove': 'Retirer l\'étiquette {{tag}}',
  'sessions.tags.all': 'Toutes les étiquettes',
  'sessions.tags.full': '10 étiquettes au plus : retirez-en une pour en ajouter',
  'sessions.tags.hint': 'Pour retrouver vos parcours : 10 étiquettes au plus, de 40 caractères chacune. Elles sont communes à toute l\'organisation, et gardent la graphie de leur première saisie.',
  'sessions.certificate.label': 'Condition de l\'attestation',
  'sessions.certificate.COMPLETION': 'Tous les modules terminés',
  'sessions.certificate.SUCCESS': 'Chaque module réussi',
  'sessions.certificate.SCORE': 'Un score minimum sur chaque module',
  'sessions.certificate.minScore': 'Score minimum, en pourcentage',
  'sessions.certificate.hint': 'Il faut toujours terminer tous les modules. Avec la réussite, seuls comptent les modules qui en déclarent une ; avec le score, seuls ceux qui en remontent un. Le score retenu est celui choisi pour chaque module.',
  'sessions.certificate.warn_one': 'Ce parcours compte {{count}} inscrit. L\'attestation suit la condition et les scores en vigueur : s\'il l\'avait déjà obtenue, cette modification peut la lui retirer.',
  'sessions.certificate.warn_other': 'Ce parcours compte {{count}} inscrits. L\'attestation suit la condition et les scores en vigueur : ceux qui l\'avaient déjà obtenue peuvent la perdre avec cette modification.',
  'sessions.progression.label': 'Progression',
  'sessions.progression.free': 'Libre',
  'sessions.progression.sequential': 'Séquentielle',
  'sessions.progression.free.hint': 'L\'apprenant suit les modules dans l\'ordre qu\'il veut.',
  'sessions.progression.sequential.hint': 'Chaque module s\'ouvre à la complétion du précédent. Une date d\'ouverture s\'y ajoute, elle ne la remplace pas.',

  // Parcours vu par l'apprenant (#139 / #182)
  // Pas de pluriel ici : i18next l'accorde sur `count`, or le nombre qui varie
  // est `done` face à `total`. La forme « x / y » évite l'accord des deux côtés.
  'home.path.summary': '{{done}} / {{total}} modules terminés',
  'home.path.opensOn': 'À partir du {{date}}',
  'home.path.awaitingPrerequisite': 'Il s\'ouvrira quand vous aurez terminé « {{title}} »',
  'home.path.awaitingScore': 'Obtenez au moins {{score}} % à « {{title}} » pour l\'ouvrir',
  'home.path.awaitingPrevious': 'Il s\'ouvrira dès que vous aurez terminé le précédent',
  'positioning.entry.title': 'Avant de commencer : positionnez-vous',
  'positioning.entry.body': 'Dites où vous en êtes sur chaque objectif de la formation, et ce que vous en attendez. Les modules s\'ouvrent dès que c\'est fait.',
  'positioning.entry.action': 'Me positionner',
  'positioning.exit.title': 'Mesurez vos progrès',
  'positioning.exit.body': 'Vous avez terminé : où en êtes-vous maintenant sur chaque objectif ? C\'est facultatif.',
  'positioning.exit.action': 'Me réévaluer',
  'positioning.dialog.description': 'Pour chaque objectif, de 1 (pas du tout) à 5 (tout à fait) : je sais le faire.',
  'positioning.dialog.needs': 'Vos attentes ou besoins pour cette formation (facultatif)',
  'positioning.dialog.later': 'Plus tard',
  'positioning.dialog.submit': 'Envoyer',
  'positioning.sent': 'Merci, c\'est enregistré.',
  'positioning.failed': 'L\'envoi a échoué. Réessayez.',
  'home.path.awaitingPositioning': 'Il s\'ouvrira dès que vous vous serez positionné sur les objectifs',
  'pathDocuments.title': 'Documents de la formation',
  'pathDocuments.required': 'À lire avant de commencer',
  'pathDocuments.download': 'Télécharger',
  'pathDocuments.acknowledge': 'J\'ai pris connaissance',
  'pathDocuments.readOn': 'Lu le {{date}}',
  'pathDocuments.acknowledgeFailed': 'L\'enregistrement a échoué. Réessayez.',
  'pathDocuments.downloadFailed': 'Le téléchargement a échoué.',
  'home.path.awaitingDocuments': 'Il s\'ouvrira dès que vous aurez pris connaissance des documents de la formation',
  'scorm.player.step': 'Étape {{current}} sur {{total}}',
  'sessions.created': 'Session créée.',
  'sessions.createFailed': 'Création échouée.',
  'sessions.deleted': 'Session supprimée.',
  'sessions.deleteFailed': 'Suppression échouée.',
  'sessions.duplicate': 'Dupliquer',
  'sessions.duplicateTitle': 'Dupliquer « {{name}} »',
  'sessions.duplicateBody': 'La copie reprend les modules, les chapitres, les règles, la fiche formation, l\'attestation, les étiquettes, les formateurs et les documents. Les dates et les apprenants ne suivent pas : vous les choisirez ensuite.',
  'sessions.duplicateName': 'Nom de la copie',
  'sessions.duplicateDefaultName': '{{name}} (copie)',
  'sessions.duplicated': 'Session dupliquée. Choisissez ses dates et ses apprenants, puis enregistrez.',
  'sessions.duplicateFailed': 'La duplication a échoué. Réessayez.',
  'sessions.deleteTitle': 'Supprimer la session « {{name}} » ?',
  'sessions.deleteBody_one': '{{count}} apprenant inscrit perd son inscription et son suivi (progression, scores, temps passé) : rien ne se récupère. Pour seulement la retirer des apprenants, archivez-la.',
  'sessions.deleteBody_other': '{{count}} apprenants inscrits perdent leur inscription et leur suivi (progression, scores, temps passé) : rien ne se récupère. Pour seulement la retirer des apprenants, archivez-la.',
  'sessions.deleteBodyEmpty': 'Aucun apprenant n\'y est inscrit. La suppression est définitive.',
  'sessions.new': 'Nouvelle session',
  'sessions.update.title': 'Modifier la session',
  'sessions.updated': 'Session mise à jour.',
  'sessions.updateFailed': 'Mise à jour échouée.',
  'sessions.openModule': 'Ouvrir le module',
  'sessions.participants.selectAll': 'Tout sélectionner',
  'sessions.trainers.label': 'Formateurs',
  'sessions.trainers.all': 'Tous les formateurs',
  'sessions.trainers.search': 'Rechercher un formateur',
  'sessions.participants.clear': 'Tout désélectionner',
  'sessions.participants.addGroup': 'Inscrire un groupe :',
  'sessions.participants.search': 'Rechercher un participant',

  // Groupes d'utilisateurs (#135)
  'groups.list.title': 'Groupes',
  'groups.new': 'Nouveau groupe',
  'groups.empty': 'Aucun groupe.',
  'groups.memberCount': 'Membres',
  'groups.members': 'Membres',
  'groups.membersSearch': 'Rechercher un membre',
  'groups.create.title': 'Créer un groupe',
  'groups.update.title': 'Modifier le groupe',
  'groups.namePlaceholder': 'Nom du groupe (ex. Mairie de Lyon)',
  'groups.nameRequired': 'Renseignez un nom.',
  'groups.nameUsed': 'Un groupe porte déjà ce nom.',
  'groups.created': 'Groupe créé.',
  'groups.createFailed': 'Création échouée.',
  'groups.updated': 'Groupe mis à jour.',
  'groups.updateFailed': 'Mise à jour échouée.',
  'groups.deleted': 'Groupe supprimé.',
  'groups.deleteFailed': 'Suppression échouée.',
  'groups.delete.title': 'Supprimer le groupe',
  'groups.delete.message': 'Supprimer « {{name}} » ? Les {{count}} membres du groupe conservent leur compte : seul le regroupement disparaît.',
  'groups.none': 'Aucun groupe',
  'groups.all': 'Tous les groupes',
  'groups.select': '— Choisir un groupe —',
  'groups.bulk.selected': '{{count}} sélectionné(s)',
  'groups.bulk.selectPage': 'Sélectionner toute la page',
  'groups.bulk.add': 'Affecter',
  'groups.bulk.remove': 'Retirer',
  'groups.bulk.added': 'Utilisateurs affectés au groupe.',
  'groups.bulk.removed': 'Utilisateurs retirés du groupe.',
  'groups.bulk.failed': 'Opération échouée.',

  // Sessions (apprenant)
  'sessions.my.title': 'Mes sessions',
  'sessions.my.empty': 'Rien à l\'horizon pour le moment.',
  'sessions.my.start': 'C\'est parti',

  // Accueil apprenant. On s'adresse à quelqu'un qui se forme sur son temps, pas
  // à un dossier : on le salue par son prénom et on lui parle de ce qui l'attend.
  'home.nav.label': 'Navigation de l\'espace de formation',
  'home.nav.dashboard': 'Tableau de bord',
  'learnerSearch.label': 'Rechercher une formation ou un module',
  'learnerSearch.placeholder': 'Rechercher…',
  'learnerSearch.group.sessions': 'Formations',
  'learnerSearch.group.modules': 'Modules',
  'learnerSearch.progress': '{{pct}} % terminé',
  'learnerSearch.count_one': '{{count}} résultat',
  'learnerSearch.count_other': '{{count}} résultats',
  'learnerSearch.locked': 'Verrouillé',
  'home.title': 'Mes formations',
  'home.section.paths': 'Vos parcours',
  'duration.hours_one': '{{count}} h',
  'duration.hours_other': '{{count}} h',
  'duration.hoursMinutes': '{{hours}} h {{minutes}}',
  'duration.minutes_one': '{{count}} min',
  'duration.minutes_other': '{{count}} min',
  'duration.lessThanMinute': 'moins d\'une minute',
  'home.meta.estimated': '{{duration}}',
  'home.meta.remaining': '{{duration}} restantes',
  'home.meta.spent': '{{duration}} passées',
  'home.meta.threshold': 'seuil {{threshold}}',
  'home.assignedOn': 'Assignée le {{date}}',
  'home.section.courses': 'Vos formations',
  'home.type.path_one': 'Parcours · {{count}} étape',
  'home.type.path_other': 'Parcours · {{count}} étapes',
  'home.type.course': 'Formation',
  'home.stepsDone': '{{done}} / {{total}} étapes terminées',
  'home.nextStep': 'Prochaine étape :',
  'home.continue': 'Continuer',
  'home.allStepsDone': 'Toutes les étapes sont terminées.',
  'path.back': 'Mes formations',
  'path.steps.title': 'Les étapes',
  'path.chapter': 'Chapitre {{number}} · {{title}}',
  'path.chapter.done': '{{done}} / {{total}} terminés',
  'path.stepOf': 'Étape {{position}} sur {{total}}',
  'path.mode.sequential': 'Les étapes s\'ouvrent l\'une après l\'autre : terminez celle en cours pour débloquer la suivante.',
  'path.mode.free': 'Vous suivez les étapes dans l\'ordre que vous voulez.',
  'path.done.title': 'Parcours terminé',
  'path.done.hint': 'Votre attestation est téléchargeable ci-dessus. Vous pouvez revoir n\'importe quelle étape autant de fois que vous le souhaitez.',
  'path.notFound': 'Cette formation n\'est plus disponible.',
  // Le français n'a que deux salutations là où l'anglais en a trois : `morning`
  // et `afternoon` disent tous deux « Bonjour ». Les clés restent découpées de
  // la même façon dans les deux langues pour que le code n'ait pas à savoir
  // laquelle en distingue combien.
  // Les variantes `_named` sont le `context` i18next : sans prénom exploitable,
  // on salue tout court plutôt que d'afficher un « Bonjour  ! » troué.
  'home.greeting.morning': 'Bonjour',
  'home.greeting.morning_named': 'Bonjour {{name}}',
  'home.greeting.afternoon': 'Bonjour',
  'home.greeting.afternoon_named': 'Bonjour {{name}}',
  'home.greeting.evening': 'Bonsoir',
  'home.greeting.evening_named': 'Bonsoir {{name}}',
  // Phrase de situation : une seule, choisie par `learnerFocus`.
  'home.focus.allDone': 'Vous avez tout terminé. Vos attestations sont téléchargeables ci-dessous.',
  'home.focus.allDoneCertificatesPending': 'Vous avez tout terminé. Certaines attestations attendent encore une condition : voyez ci-dessous ce qu\'il manque.',
  'home.focus.deadlineToday': 'Dernier jour pour terminer « {{session}} ».',
  'home.focus.deadline_one': 'Il vous reste {{count}} jour pour terminer « {{session}} ».',
  'home.focus.deadline_other': 'Il vous reste {{count}} jours pour terminer « {{session}} ».',
  'home.focus.resume': 'Reprenez « {{session}} » là où vous en étiez.',
  'home.focus.start': '« {{session}} » vous attend, quand vous voulez.',
  'home.status.completed': 'Terminée',
  'home.status.notStarted': 'À commencer',
  'home.inProgress': 'En cours',
  'home.retake': 'Recommencer',
  'home.resume': 'Reprendre',
  'home.review': 'Revoir',
  'home.completedOn': 'Terminé le',
  'home.certificate.noRetake': 'Attestation : {{titles}} ne peut plus être refait. Contactez votre formateur.',
  'home.certificate.notPassed': 'Attestation : réussissez {{titles}} pour l\'obtenir.',
  'home.certificate.scoreTooLow': 'Attestation : obtenez au moins {{score}} % à {{titles}} pour l\'obtenir.',
  'home.certificate.download': 'Attestation',
  'survey.title': 'Votre avis sur cette formation',
  'survey.intro': 'Quelques questions avant votre attestation. Tout est facultatif, et vos réponses sont lues sans votre nom.',
  'survey.modules.title': 'Chaque module vous a-t-il été utile ?',
  'survey.scale.low': 'Pas du tout',
  'survey.scale.high': 'Tout à fait',
  'survey.scale.option': '{{rating}} sur 5',
  'survey.skip': 'Passer',
  'survey.submit': 'Envoyer',
  'surveyEditor.title': 'Questionnaire',
  'surveyEditor.intro': 'Proposé à chaque apprenant juste avant son attestation, sans obligation : il peut le passer. Les réponses sont lues sans nom, dans la fiche de chaque session. La question de satisfaction globale fait le taux de satisfaction ; chaque module est aussi noté, à part. Les réponses déjà données gardent les libellés qu\'elles ont lus.',
  'surveyEditor.question': 'Question {{number}}',
  'surveyEditor.kind': 'Réponse',
  'surveyEditor.kind.scale': 'Note de 1 à 5',
  'surveyEditor.kind.text': 'Texte libre',
  'surveyEditor.overall': 'Satisfaction globale (base du taux)',
  'surveyEditor.moveUp': 'Monter {{name}}',
  'surveyEditor.moveDown': 'Descendre {{name}}',
  'surveyEditor.remove': 'Supprimer {{name}}',
  'surveyEditor.add': 'Ajouter une question',
  'surveyEditor.saved': 'Questionnaire enregistré',
  'surveyEditor.saveFailed': 'Le questionnaire n\'a pas pu être enregistré.',
  'surveyEditor.error.empty': 'Gardez au moins une question.',
  'surveyEditor.error.label': 'Chaque question doit avoir un libellé.',
  'surveyEditor.error.overall': 'Choisissez une question notée de 1 à 5 comme satisfaction globale.',
  'survey.results.title': 'Satisfaction des apprenants',
  'survey.results.empty': 'Aucun apprenant n\'a encore reçu le questionnaire : il est proposé au moment de l\'attestation.',
  'survey.results.satisfaction': 'Taux de satisfaction',
  'survey.results.satisfactionMethod': 'Notes de 4 ou 5 ÷ notes données à la satisfaction globale',
  'survey.results.responses': 'Réponses',
  'survey.results.skipped_one': '{{count}} apprenant a passé le questionnaire',
  'survey.results.skipped_other': '{{count}} apprenants ont passé le questionnaire',
  'survey.results.questions': 'Questions',
  'survey.results.modules': 'Évaluation des modules',
  'survey.results.comments': 'Commentaires',
  'survey.results.average': '{{average}} / 5 ({{count}})',
  'home.certificate.error': 'Votre attestation n\'a pas pu être téléchargée. Réessayez dans un instant.',
  'home.summary_one': '{{count}} formation terminée sur {{total}}',
  'home.summary_other': '{{count}} formations terminées sur {{total}}',
  // Légende sous « 1 / 3 » dans le bandeau : le total est déjà affiché à côté.
  'home.summaryCaption_one': 'formation terminée',
  'home.summaryCaption_other': 'formations terminées',
  // Bouton du bandeau : il mène à la formation que nomme la phrase de situation.
  'home.hero.resume': 'Reprendre',
  'home.hero.start': 'Commencer',
  'home.empty.hint': 'Dès qu\'un formateur vous inscrira à une formation, elle apparaîtra ici.',

  // Attestations (back-office)
  'common.certificates': 'Attestations',
  'certificates.template.title': 'Modèle d\'attestation',
  'certificates.field.title': 'Titre',
  'certificates.field.body': 'Texte',
  'certificates.field.signature': 'Signature',
  'certificates.field.signaturePlaceholder': 'Nom du signataire (optionnel)',
  'certificates.field.showScore': 'Afficher le score',
  'certificates.field.showDate': 'Afficher la date',
  'certificates.field.showTotalTime': 'Afficher le temps passé',
  'certificates.email.title': 'Prévenir l\'apprenant',
  'certificates.field.emailOnUnlock': 'Envoyer un e-mail quand l\'attestation est disponible',
  'certificates.email.help': 'Pour les parcours qui utilisent ce modèle, l\'apprenant reçoit un e-mail avec le lien vers son parcours au moment où son attestation devient disponible : tout terminé, condition d\'attestation remplie. Un seul e-mail par parcours ; les attestations obtenues avant l\'activation n\'en déclenchent pas.',
  'certificates.field.orientation': 'Orientation',
  'certificates.orientation.landscape': 'Paysage',
  'certificates.orientation.portrait': 'Portrait',
  'certificates.field.logo': 'Logo de l\'attestation',
  'certificates.logo.help': 'PNG ou JPEG, 512 Ko max. Sinon, le logo de la plateforme est utilisé.',
  'certificates.logo.fallback': 'Aucun logo dédié — le logo de la plateforme sera utilisé.',
  'certificates.logo.upload': 'Téléverser',
  'certificates.logo.remove': 'Retirer',
  'certificates.logo.typeError': 'Format non supporté : PNG ou JPEG uniquement.',
  'certificates.logo.sizeError': 'Fichier trop volumineux (512 Ko max).',
  'certificates.logo.readError': 'Lecture du fichier impossible.',
  'certificates.field.skeleton': 'Squelette PDF (papier à en-tête)',
  'certificates.skeleton.help': 'PDF 1 page, 3 Mo max, non protégé. Sert de fond ; le cadre décoratif n\'est alors pas dessiné.',
  'certificates.skeleton.active': 'Squelette chargé',
  'certificates.skeleton.none': 'Aucun squelette',
  'certificates.skeleton.upload': 'Téléverser un PDF',
  'certificates.skeleton.replace': 'Remplacer',
  'certificates.skeleton.remove': 'Retirer',
  'certificates.skeleton.typeError': 'Le squelette doit être un fichier PDF.',
  'certificates.skeleton.sizeError': 'PDF trop volumineux (3 Mo max).',
  'certificates.skeleton.readError': 'Lecture du PDF impossible.',
  'certificates.field.margins': 'Marges du texte (points)',
  'certificates.margins.help': 'Position du bloc de texte, surtout utile avec un squelette. 0 à 300.',
  'certificates.margins.marginTop': 'Haut',
  'certificates.margins.marginBottom': 'Bas',
  'certificates.margins.marginLeft': 'Gauche',
  'certificates.margins.marginRight': 'Droite',
  'certificates.placeholders.help': 'Variables disponibles :',
  'certificates.preview': 'Prévisualiser',
  'certificates.previewError': 'Impossible de générer la prévisualisation.',
  'certificates.saved': 'Modèle enregistré.',
  'certificates.saveError': 'Échec de l\'enregistrement.',
  'trainerCapabilities.intro': 'Choisissez ce que le rôle Formateur peut faire dans votre organisation. Ces réglages s\'appliquent à tous les formateurs ; les administrateurs gardent tous leurs droits. Bon à savoir : un parcours visible montre ses inscrits, et l\'export CSV est masqué sans le droit d\'exporter, mais il reprend la table de suivi, que le formateur voit déjà.',
  'trainerCapabilities.domain.sessions': 'Parcours',
  'trainerCapabilities.domain.modules': 'Modules',
  'trainerCapabilities.domain.learners': 'Apprenants',
  'trainerCapabilities.domain.statistics': 'Statistiques',
  'trainerCapabilities.cap.SESSIONS_VIEW': 'Voir les parcours',
  'trainerCapabilities.cap.SESSIONS_MANAGE': 'Créer et modifier les parcours',
  'trainerCapabilities.cap.SESSIONS_DELETE': 'Supprimer les parcours',
  'trainerCapabilities.cap.MODULES_VIEW': 'Voir et prévisualiser les modules',
  'trainerCapabilities.cap.MODULES_IMPORT': 'Importer des modules',
  'trainerCapabilities.cap.MODULES_DELETE': 'Supprimer les modules',
  'trainerCapabilities.cap.LEARNERS_VIEW': 'Ouvrir l\'écran Apprenants (et les groupes)',
  'trainerCapabilities.cap.STATISTICS_VIEW': 'Voir le suivi et les statistiques',
  'trainerCapabilities.cap.STATISTICS_EXPORT': 'Exporter les statistiques (PDF, CSV)',
  'trainerCapabilities.requires': 'Suppose : {{list}}',
  'trainerCapabilities.loadError': 'Impossible de charger les droits du formateur. Rechargez la page avant de les modifier.',
  'trainerCapabilities.saved': 'Droits du formateur enregistrés.',
  'trainerCapabilities.saveError': 'Échec de l\'enregistrement.',
  'common.reminders': 'Rappels email',
  'reminders.cadence.title': 'Cadence des rappels',
  'reminders.message.title': 'Message envoyé',
  'reminders.field.enabled': 'Activer les rappels',
  'reminders.enabled.help': 'Les apprenants inscrits qui n\'ont pas terminé leur formation reçoivent une relance automatique.',
  'reminders.digest.title': 'Récapitulatif des parcours terminés',
  'reminders.field.completionDigestEnabled': 'Envoyer chaque matin le récapitulatif aux administrateurs',
  'reminders.convocation.title': 'Convocation à l\'inscription',
  'reminders.field.convocationEnabled': 'Envoyer une convocation à chaque apprenant inscrit',
  'reminders.convocation.help': 'L\'apprenant reçoit le nom du parcours, ses dates, sa durée estimée et le lien d\'accès. Les comptes sans adresse e-mail n\'en reçoivent pas. La date d\'envoi s\'exporte dans les rapports.',
  'reminders.digest.help': 'Chaque jour vers 7 h (heure de votre organisation), tous les administrateurs reçoivent la liste des parcours terminés depuis le précédent récapitulatif. Rien n\'est envoyé s\'il n\'y a rien de nouveau.',
  'reminders.field.firstDelayDays': 'Délai avant le 1er rappel (jours)',
  'reminders.field.frequencyDays': 'Intervalle entre deux rappels (jours)',
  'reminders.frequencyDays.help': '3 jours minimum : en dessous, la relance passe pour du spam.',
  'reminders.field.maxReminders': 'Nombre maximum de rappels',
  'reminders.maxReminders.help': 'Entre 1 et 10 rappels par inscription. L\'option « sans limite » n\'existe plus : relancer indéfiniment fait classer vos messages en spam, y compris les convocations et les attestations.',
  'reminders.field.sendHour': 'Heure d\'envoi (0-23)',
  'reminders.field.subject': 'Objet',
  'reminders.field.body': 'Corps du message',
  'reminders.placeholders.help': 'Variables disponibles :',
  'reminders.sendTest': 'M\'envoyer un test',
  'reminders.testSent': 'Rappel de test envoyé à {{email}}.',
  'reminders.testError': 'Échec de l\'envoi du test. Vérifiez la configuration SMTP.',
  'reminders.saved': 'Rappels enregistrés.',
  'reminders.saveError': 'Échec de l\'enregistrement.',

  // SSO (#40)
  'common.trainerCapabilities': 'Droits du formateur',
  'common.webhooks': 'Webhooks',
  'common.sso': 'Authentification SSO',
  'sso.picker.title': 'Fournisseur à configurer',
  'sso.picker.help': 'Choisissez un fournisseur pour afficher ses champs. Vous pouvez en configurer et en activer plusieurs : ceux qui ne sont pas à l\'écran restent en place.',
  'sso.picker.configured': 'Déjà configurés :',
  'sso.picker.none': 'Aucun fournisseur configuré pour le moment.',
  'sso.picker.status.enabled': 'activé',
  'sso.picker.status.draft': 'brouillon',
  'webhooks.intro': 'Studeva prévient votre système (SIRH, ERP de formation…) quand un apprenant termine un module ou un parcours : un appel HTTPS signé, rejoué jusqu\'à ce qu\'il soit reçu.',
  'webhooks.endpoint.title': 'Destination',
  'webhooks.endpoint.url': 'URL qui reçoit les appels',
  'webhooks.endpoint.urlHelp': 'HTTPS obligatoire, sur un hôte joignable depuis Internet.',
  'webhooks.endpoint.enabled': 'Envoyer les appels',
  'webhooks.saved': 'Destination enregistrée.',
  'webhooks.saveError': 'Échec de l\'opération.',
  'webhooks.secret.copyFailed': 'Copie impossible : sélectionnez le secret et copiez-le à la main.',
  'webhooks.secret.regenerateTitle': 'Remplacer le secret ?',
  'webhooks.secret.regenerateWarning': 'L\'ancien secret cessera aussitôt de signer : votre système refusera nos appels tant qu\'il n\'aura pas le nouveau.',
  'webhooks.deliveries.nextAttempt': 'Prochain essai : {{date}}',
  'webhooks.error.TIMEOUT': 'Délai dépassé',
  'webhooks.error.BLOCKED_ADDRESS': 'Adresse interne refusée',
  'webhooks.error.DNS': 'Nom introuvable',
  'webhooks.error.TLS': 'Certificat refusé',
  'webhooks.error.CONNECTION': 'Connexion refusée',
  'webhooks.error.DESTINATION_OFF': 'Destination désactivée',
  'webhooks.error.INVALID_URL': 'URL refusée',
  'webhooks.error.UNKNOWN': 'Erreur inconnue',
  'webhooks.secret.title': 'Secret de signature',
  'webhooks.secret.once': 'Copiez ce secret maintenant : il ne sera plus jamais affiché.',
  'webhooks.secret.copy': 'Copier le secret',
  'webhooks.secret.copied': 'Secret copié.',
  'webhooks.secret.hidden': 'Le secret est enregistré et n\'est plus affiché. Remplacez-le si vous l\'avez perdu.',
  'webhooks.secret.none': 'Un secret est généré à l\'enregistrement de la destination.',
  'webhooks.secret.verify': 'Chaque appel porte l\'en-tête X-Studeva-Signature : t=<horodatage>,v1=<HMAC-SHA256 de « horodatage.corps » avec ce secret>. Recalculez-le pour vérifier que l\'appel vient bien de Studeva.',
  'webhooks.secret.regenerate': 'Remplacer le secret',
  'webhooks.test': 'Envoyer un test',
  'webhooks.testQueued': 'Appel de test mis en file : il part dès que possible.',
  'webhooks.deliveries.title': 'Derniers envois',
  'webhooks.deliveries.empty': 'Aucun envoi pour l\'instant.',
  'webhooks.deliveries.date': 'Date',
  'webhooks.deliveries.event': 'Événement',
  'webhooks.deliveries.attempts': 'Essais',
  'webhooks.deliveries.response': 'Dernière réponse',
  'webhooks.status.PENDING': 'En file',
  'webhooks.status.SENDING': 'En cours',
  'webhooks.status.DELIVERED': 'Reçu',
  'webhooks.status.FAILED': 'Abandonné',
  'sso.intro': 'Activez un ou plusieurs fournisseurs d\'identité pour votre organisation. Tant qu\'aucun n\'est activé, l\'écran de connexion n\'affiche aucun bouton SSO.',
  'sso.master.title': 'Connexion par SSO',
  'sso.master.help': 'Interrupteur général, au-dessus des fournisseurs. Désactivé tant que vous ne l\'allumez pas ; le couper à nouveau retire tous les boutons SSO de l\'écran de connexion sans effacer les configurations ci-dessous.',
  'sso.master.off': 'Le SSO est coupé : aucun bouton n\'apparaît sur l\'écran de connexion, même pour les fournisseurs activés ci-dessous.',
  'sso.master.turnedOn': 'Connexion par SSO activée.',
  'sso.master.turnedOff': 'Connexion par SSO coupée.',
  'sso.field.enabled': 'Activé',
  'sso.field.label': 'Libellé du bouton',
  'sso.label.help': 'Texte affiché sur l\'écran de connexion.',
  'sso.field.issuer': 'Issuer',
  'sso.field.clientId': 'Client ID',
  'sso.field.clientSecret': 'Client secret',
  'sso.clientSecret.help': 'Chiffré avant enregistrement. Il ne sera plus jamais réaffiché.',
  'sso.clientSecret.stored': 'Secret enregistré. Laissez vide pour le conserver.',
  'sso.field.entryPoint': 'URL de connexion de l\'IdP',
  'sso.field.idpIssuer': 'Entity ID de l\'IdP',
  'sso.field.idpCert': 'Certificat de signature (PEM)',
  'sso.field.allowedDomains': 'Domaines email autorisés',
  'sso.allowedDomains.help': 'Vide = tout domaine renvoyé par le fournisseur est accepté. Un compte est créé automatiquement à la première connexion.',
  'sso.allowedDomains.required': 'Ce fournisseur authentifie aussi des comptes hors de votre organisation — toute adresse Gmail dans le cas de Google. Renseignez au moins un domaine pour pouvoir l\'activer.',
  'sso.idpSetup.title': 'À déclarer côté fournisseur :',
  'sso.saved': 'Fournisseur enregistré.',
  'sso.saveError': 'Échec de l\'enregistrement.',
  'sso.deleted': 'Fournisseur supprimé.',
  'sso.deleteError': 'Échec de la suppression.',
  'sso.delete.title': 'Supprimer {{provider}}',
  'sso.delete.first-message': 'La configuration et le client secret seront perdus : le rétablir suppose d\'en réémettre un côté fournisseur. Si ce fournisseur est activé, les apprenants qui passent par lui ne pourront plus se connecter.',
  'sso.callback.checking': 'Connexion en cours',
  'sso.callback.checking.description': 'Nous validons votre identité auprès de votre fournisseur.',
  'sso.callback.failed.title': 'Connexion impossible',
  'sso.callback.failed.description': 'Le lien de connexion a expiré ou a déjà été utilisé. Relancez la connexion depuis l\'écran d\'accueil.',
  'sso.error.demoLearnerLimit': 'Votre organisme a atteint le nombre maximal d\'apprenants de son espace de démonstration. Contactez son administrateur.',
  'sso.error.generic': 'La connexion SSO a échoué. Réessayez ou contactez votre administrateur.',
  'sso.error.domainNotAllowed': 'Votre domaine email n\'est pas autorisé pour cette organisation.',
  'sso.error.accountDisabled': 'Votre compte est désactivé. Contactez votre administrateur.',
  'sso.error.emailAlreadyUsed': 'Cette adresse est déjà rattachée à une autre organisation.',
  'sso.error.providerUnavailable': 'Ce fournisseur d\'identité est indisponible.',

  // Player SCORM. Ces écrans-ci sont vus par l'apprenant : on lui dit ce qui se
  // passe et ce qu'il peut faire, pas ce qui a échoué côté serveur. « SCORM »
  // et « session » sont du vocabulaire d'outil et n'ont rien à y faire.
  'scorm.player.backToSessions': 'Mes formations',
  'scorm.player.unavailable': 'Ce module n\'est pas accessible pour le moment.',
  'scorm.player.retakeNotAllowed': 'Vous avez terminé ce module, et il ne peut pas être refait.',
  'scorm.player.contentError': 'Ce module n\'a pas pu être ouvert. Prévenez votre formateur, il pourra le remettre en ligne.',

  // Écran de fin du player (le module a appelé Terminate)
  'scorm.finished.completedTitle': 'Félicitations, vous avez terminé ce module !',
  'scorm.finished.pathCompletedTitle': 'Félicitations, vous avez terminé toute la formation !',
  'scorm.finished.pathCompletedHint': 'Votre attestation vous attend sur la page d\'accueil.',
  'scorm.finished.title': 'Fin du module',

  // Impersonation dans le player
  'scorm.impersonate.noTracking': 'Mode consultation : progression non enregistrée',

  // Prévisualisation module (Admin/Formateur)
  'scorm.preview.badge': 'Prévisualisation',
  'scorm.preview.noTracking': 'Aucune progression n\'est enregistrée.',
  'scorm.preview.backToModules': 'Retour aux modules',
  'scorm.preview.unavailable': 'Ce module n\'est pas prêt à être joué.',

  // Export statistiques
  'stats.export.email': 'Email',
  'stats.export.session': 'Session',
  'stats.export.completion': 'Complétion',
  'stats.export.success': 'Réussite',
  'stats.export.score': 'Score',
  'stats.export.totalTime': 'Temps total',
  'stats.export.completedAt': 'Complété le',

  // Tableau de bord statistiques
  'stats.dashboard.progressTitle': 'Avancement',
  'stats.dashboard.scopeTitle': 'Avancement global',
  'stats.report.download': 'Rapport PDF',
  'stats.report.failed': 'Le rapport n\'a pas pu être généré.',
  'stats.trend.title': 'Modules terminés sur la période',
  'stats.trend.range': 'Profondeur de la courbe',
  'stats.trend.days_one': '{{count}} jour',
  'stats.trend.days_other': '{{count}} jours',
  'stats.trend.empty': 'Aucun module terminé sur cette période.',
  'stats.trend.tooltip_one': '{{count}} module terminé le {{day}}',
  'stats.trend.tooltip_other': '{{count}} modules terminés le {{day}}',
  'stats.trend.alt': 'Courbe des modules terminés : {{count}} au total sur les {{days}} derniers jours.',
  'stats.dashboard.scope': 'Apprenants inscrits à une session',
  'stats.dashboard.breakdownBasis': 'Répartition calculée module par module ({{modules}} au total) : un apprenant inscrit à un parcours de trois modules y compte trois fois.',
  'stats.dashboard.noModules': 'Leurs sessions ne contiennent encore aucun module : rien à mesurer pour l\'instant.',
  'stats.dashboard.noEnrollments': 'Aucun apprenant inscrit sur ce périmètre.',
  'stats.dashboard.notYetUnlocked': 'Pas encore ouvert',
  'stats.dashboard.notYetUnlocked.hint': '{{modules}} modules ne sont pas encore débloqués pour leurs apprenants : ils comptent dans l\'effectif sans compter comme du retard.',
  'stats.dashboard.neverOpened': '{{learners}} inscrits n\'ont jamais ouvert leur module : ils comptent dans l\'effectif, mais ne figurent pas dans la table ci-dessous.',
  'stats.dashboard.averageScore': 'Moyenne des résultats',
  'stats.dashboard.scoredOn': 'sur {{scored}} parcours notés sur {{total}}',
  'stats.dashboard.noScore': 'Aucun score renseigné sur ce périmètre',
  'stats.dashboard.successRate': 'Taux de réussite',
  'stats.dashboard.successOn': '{{passed}} réussis sur {{evaluated}} évalués',
  'stats.dashboard.noSuccess': 'Aucun verdict de réussite sur ce périmètre',
  'stats.dashboard.averageTime': 'Temps moyen passé',
  'stats.dashboard.totalTime': 'Temps total en formation',
  'stats.dashboard.timedOn': 'sur {{timed}} parcours chronométrés sur {{total}}',
  'stats.dashboard.noTime': 'Aucune durée relevée sur ce périmètre',

  // Accueil back-office (#201). Des phrases, pas des libellés d'indicateur :
  // chaque ligne de cet écran se lit à voix haute. Le ton est celui d'un
  // collègue qui fait le point le matin — cordial, jamais comptable : on dit
  // « il reste des gens à accompagner », pas « 4 non-conformités ».
  'common.routing.home': 'Accueil',
  'backHome.greeting': 'Bonjour {{name}}',
  'backHome.subtitle.attention_one': 'Quelque chose vous attend aujourd\'hui.',
  'backHome.subtitle.attention_other': '{{count}} choses vous attendent aujourd\'hui.',
  'backHome.subtitle.clear': 'Tout est à jour : rien ne vous attend aujourd\'hui.',
  'backHome.section.attention': 'À regarder de près',
  'backHome.section.upcoming': 'Ça arrive bientôt',
  'backHome.section.today': 'Les bonnes nouvelles du jour',
  'backHome.overdue.title_one': '{{name}} : {{count}} apprenant n\'a pas encore terminé',
  'backHome.overdue.title_other': '{{name}} : {{count}} apprenants n\'ont pas encore terminé',
  // Sans pronom d'objet : « les relancer » sonne faux sur une ligne qui ne
  // compte qu'un apprenant, et « le » supposerait un genre.
  'backHome.overdue.detail': 'L\'échéance était le {{date}}. C\'est le moment de relancer.',
  'backHome.overdue.more_one': 'Et {{count}} autre parcours dans le même cas.',
  'backHome.overdue.more_other': 'Et {{count}} autres parcours dans le même cas.',
  'backHome.overdue.learners_one': 'En tout, {{count}} apprenant est concerné.',
  'backHome.overdue.learners_other': 'En tout, {{count}} apprenants sont concernés, certains sur plusieurs parcours.',
  'backHome.endingSoon.title': '{{name}} se termine le {{date}}',
  'backHome.endingSoon.detail_one': 'Il reste {{count}} apprenant sur {{total}} à accompagner.',
  'backHome.endingSoon.detail_other': 'Il reste {{count}} apprenants sur {{total}} à accompagner.',
  'backHome.startingSoon.title': '{{name}} démarre le {{date}}',
  'backHome.startingSoon.detail_one': '{{count}} apprenant est attendu.',
  'backHome.startingSoon.detail_other': '{{count}} apprenants sont attendus.',
  'backHome.completedToday.title_one': '{{count}} apprenant a bouclé « {{module}} »',
  'backHome.completedToday.title_other': '{{count}} apprenants ont bouclé « {{module}} »',
  'backHome.neverStarted.title_one': '{{count}} apprenant n\'a pas encore fait ses premiers pas',
  'backHome.neverStarted.title_other': '{{count}} apprenants n\'ont pas encore fait leurs premiers pas',
  // Accordé au nombre, et sans pronom : « il » supposerait un genre qu'on ne
  // connaît pas, et le masculin générique désignerait ici des personnes réelles.
  'backHome.neverStarted.detail_one': 'Inscrit à un parcours déjà démarré, sans avoir encore ouvert de module.',
  'backHome.neverStarted.detail_other': 'Inscrits à un parcours déjà démarré, sans avoir encore ouvert de module.',
  'backHome.empty': 'Rien à signaler : pas d\'échéance proche, personne à relancer. Profitez-en.',
  'backHome.empty.cta': 'Jeter un œil aux parcours',

  'notice.stats.title': 'Vos données et le suivi de votre formation',
  'notice.stats.intro': '{{appName}} enregistre votre progression afin de produire le suivi pédagogique de votre formation. Cette information vous est donnée à titre de transparence : elle n’appelle aucune démarche de votre part.',
  'notice.stats.purpose': 'Finalité : mesurer votre progression, votre assiduité et votre réussite, et produire les attestations et justificatifs que votre organisme de formation doit être en mesure de fournir.',
  'notice.stats.data': 'Données concernées : votre identité (nom, prénom, adresse e-mail) associée à votre progression sur les modules, ainsi que le journal de vos connexions (date et moyen de connexion), conservé 12 mois.',
  'notice.stats.legalBasis': 'Base légale : l’exécution de votre contrat de formation (article 6.1.b du RGPD) et les obligations légales de traçabilité qui pèsent sur votre organisme de formation (article 6.1.c).',
  'notice.stats.rights': 'Vos droits : accès, rectification, limitation et opposition s’exercent auprès de votre organisme de formation. Cette notice reste consultable à tout moment via le lien « Mes données ».',
  'notice.stats.noConsentNeeded': 'Ce traitement ne repose pas sur votre consentement : il n’y a rien à accepter ni à refuser, et votre accès à vos formations n’en dépend pas.',
  'notice.stats.manage': 'Mes données',

  // Parcours d'inscription qualifié (#155)
  'findOrganization.title': 'Se connecter',
  'findOrganization.subtitle': 'Chaque organisme de formation a son propre espace sur Studeva. Indiquez le vôtre pour rejoindre son écran de connexion.',
  'findOrganization.field': 'Identifiant de votre organisme',
  'findOrganization.placeholder': 'mon-organisme',
  'findOrganization.hint': 'Il figure dans l\'adresse de votre espace, après « /o/ ». Vous pouvez aussi coller cette adresse. Votre organisme vous l\'a communiqué avec votre invitation.',
  'findOrganization.submit': 'Continuer',
  'findOrganization.error.unknown': 'Aucun organisme ne porte cet identifiant. Vérifiez-le dans l\'e-mail d\'invitation de votre organisme, ou demandez-le à son administrateur.',
  'findOrganization.error.generic': 'La recherche n\'a pas abouti. Réessayez dans quelques instants.',
  'signup.title': 'Créer votre espace d\'essai',
  'signup.choice.subtitle': 'Qui êtes-vous ? Nous adaptons la suite à votre profil.',
  'signup.choice.org.title': 'Je suis un organisme de formation',
  'signup.choice.org.description': 'Créez votre espace d\'essai gratuit et invitez vos apprenants.',
  'signup.choice.learner.title': 'Je suis un apprenant ou un formateur',
  'signup.choice.learner.description': 'Vous rejoignez un organisme existant.',
  'signup.learner.description': 'Les comptes apprenant et formateur sont créés par votre organisme de formation. Rapprochez-vous de son administrateur : il vous enverra une invitation par e-mail. Il n\'y a pas d\'inscription libre pour ces profils.',
  'signup.back': 'Retour',
  'signup.form.subtitle': 'Quelques informations pour ouvrir votre espace. Aucune carte bancaire requise.',
  'signup.form.email': 'E-mail professionnel',
  'signup.form.email.hint': 'Utilisez l\'adresse de votre organisme — les adresses grand public (gmail, outlook…) ne sont pas acceptées.',
  'signup.form.orgName': 'Nom de l\'organisme',
  'signup.form.jobTitle': 'Fonction (facultatif)',
  'signup.form.phone': 'Téléphone (facultatif)',
  'signup.form.submit': 'Créer mon espace d\'essai',
  'signup.form.terms': 'J\'accepte les <cgv>conditions générales de vente</cgv> et les <cgu>conditions générales d\'utilisation</cgu>.',
  'signup.form.terms.required': 'Acceptez les conditions générales pour créer votre espace.',
  'legal.acceptance.title': 'Conditions de la plateforme',
  'legal.acceptance.intro': 'Pour continuer, prenez connaissance des documents suivants et acceptez-les. Ils s\'ouvrent dans un nouvel onglet.',
  'legal.acceptance.version': 'version du {{version}}',
  'legal.links.newTab': '(s\'ouvre dans un nouvel onglet)',
  'legal.acceptance.accept': 'J\'accepte',
  'legal.acceptance.error': 'Votre acceptation n\'a pas pu être enregistrée. Réessayez.',
  'legal.document.TERMS_OF_USE': 'Conditions générales d\'utilisation',
  'legal.document.TERMS_OF_SALE': 'Conditions générales de vente',
  'legal.document.PRIVACY': 'Politique de confidentialité',
  'legal.links.label': 'Informations légales',
  'signup.sent.title': 'Vérifiez votre boîte mail',
  'signup.sent.description': 'Si une adresse professionnelle valide a été fournie, un e-mail de confirmation vient d\'être envoyé à {{email}}. Cliquez sur le lien qu\'il contient pour confirmer votre adresse — votre demande sera ensuite examinée par notre équipe.',
  'signup.error.publicEmail': 'Merci d\'utiliser une adresse e-mail professionnelle.',
  'signup.error.generic': 'Une erreur est survenue. Réessayez dans un instant.',

  'confirmTrial.title': 'Confirmation de votre e-mail',
  'confirmTrial.loading': 'Nous enregistrons votre confirmation…',
  'confirmTrial.pending': 'Merci ! Votre adresse est confirmée. Votre demande est maintenant examinée par notre équipe — vous recevrez un e-mail dès qu\'elle sera validée.',
  'confirmTrial.approved': 'Votre espace a été validé ! Consultez l\'e-mail d\'activation que nous venons de vous envoyer pour définir votre mot de passe.',
  'confirmTrial.goToLogin': 'Aller à la connexion',
  'confirmTrial.rejected': 'Votre demande n\'a pas été retenue.',
  'confirmTrial.reason': 'Motif :',
  'confirmTrial.expired': 'Ce lien de confirmation a expiré. Relancez une demande d\'essai pour en recevoir un nouveau.',
  'confirmTrial.error': 'Ce lien de confirmation est invalide.',
  'confirmTrial.restart': 'Relancer une demande',

  // Revue plateforme des demandes d'essai (#155, SuperAdmin)
  'trialRequests.title': 'Demandes d\'essai',
  'trialRequests.intro': 'Les organismes qui ont confirmé leur adresse et attendent la création de leur espace.',
  'trialRequests.empty': 'Aucune demande en attente.',
  'trialRequests.col.org': 'Organisme',
  'trialRequests.col.requester': 'Demandeur',
  'trialRequests.col.jobTitle': 'Fonction',
  'trialRequests.col.confirmedAt': 'Confirmée le',
  'trialRequests.col.actions': 'Actions',
  'trialRequests.approve': 'Approuver',
  'trialRequests.reject': 'Refuser',
  'trialRequests.approved': 'Espace créé pour {{org}} — l\'activation a été envoyée.',
  'trialRequests.rejected': 'Demande de {{org}} refusée.',
  'trialRequests.error': 'Une erreur est survenue.',
  'trialRequests.rejectTitle': 'Refuser la demande de {{org}} ?',
  'trialRequests.reasonLabel': 'Motif du refus (facultatif)',
  'trialRequests.reasonPlaceholder': 'Ex. : organisme non identifiable…',
  'trialRequests.reasonHelp': 'Le motif est inclus dans l\'e-mail envoyé au demandeur.',
  'trialRequests.confirmReject': 'Refuser et prévenir',

  // Gating des capacités par formule (#155)

  // Renommage de slug d'organisation (#155)
  'organization.rename.title': 'Renommer l\'organisation ?',
  'organization.rename.warning': 'Vous changez le slug de « {{from}} » vers « {{to}} ». Ce changement est immédiat et casse tout ce qui pointe vers l\'ancienne adresse.',
  'organization.rename.break.urls': 'Les liens et favoris vers l\'ancienne adresse cessent de fonctionner.',
  'organization.rename.break.login': 'L\'écran de connexion et le branding résolus par l\'ancien slug ne répondent plus.',
  'organization.rename.break.emails': 'Les e-mails déjà envoyés (connexion, activation, rappels) pointent vers l\'ancienne adresse.',
  'organization.rename.confirm': 'Renommer malgré tout',
  'pageTitle.findOrganization': 'Se connecter',
  'pageTitle.login': 'Connexion',
  'pageTitle.logout': 'Déconnexion',
  'pageTitle.resetPassword': 'Mot de passe oublié',
  'pageTitle.newPassword': 'Nouveau mot de passe',
  'pageTitle.validAccount': 'Validation du compte',
  'pageTitle.createAccount': 'Création du compte',
  'pageTitle.magicLink': 'Connexion par lien',
  'pageTitle.sso': 'Connexion SSO',
  'pageTitle.denied': 'Accès refusé',
  'pageTitle.signup': 'Créer votre espace',
  'pageTitle.confirmTrial': 'Confirmation de l\'essai',
  'pageTitle.demoPath': 'Démonstration : parcours',
  'pageTitle.demoPlayer': 'Démonstration : lecteur',
  'pageTitle.demoSession': 'Démonstration : fiche session',
  'pageTitle.demoPreview': 'Démonstration : prévisualisation',
  'pageTitle.path': 'Parcours',
  'pageTitle.player': 'Lecteur de module',
  'pageTitle.preview': 'Prévisualisation du module',
  'pageTitle.error': 'Erreur',
  'pageTitle.notFound': 'Page introuvable',
  'pageTitle.announce': 'Page : {{title}}',
  'a11y.skipToContent': 'Aller au contenu',
  'a11y.backOfficeNav': 'Navigation du back-office',
  'path.step.status.done': 'Terminé',
  'path.step.status.available': 'Disponible',
  'path.step.status.locked': 'Verrouillé',
  'score.passed': 'seuil atteint',
  'score.notPassed': 'seuil non atteint',
  'common.actionFor': '{{action}} : {{name}}',
  'users.you': '(vous)',
  'users.empty': 'Aucun utilisateur.',
  'form.requiredHint': 'Les champs marqués d\'un astérisque (*) sont obligatoires.',
  'users.import.previewTable': 'Aperçu de l\'import',
  'billing.learnerCounters.table': 'Apprenants par organisation',
  'path.progress.label': 'Progression du parcours',
  'storage.usage.progress': 'Espace de stockage utilisé',
  'login.language.toggle': '{{current}} — passer en {{target}}',
  'learner.logoLink': '{{appName}} — Mes formations',
  'sessions.path.dnd.instructions': 'Pour déplacer un module, appuyez sur Espace ou Entrée pour le saisir, utilisez les flèches haut et bas, puis Espace ou Entrée pour le déposer, ou Échap pour annuler.',
  'sessions.path.dnd.start': '« {{title}} » saisi, position {{position}} sur {{total}}.',
  'sessions.path.dnd.over': '« {{title}} » en position {{position}} sur {{total}}.',
  'sessions.path.dnd.end': '« {{title}} » déposé en position {{position}} sur {{total}}.',
  'sessions.path.dnd.cancel': 'Déplacement de « {{title}} » annulé.',
  'scorm.player.titleNamed': 'Module : {{name}}',
  'common.resultsCount_one': '{{count}} résultat',
  'common.resultsCount_other': '{{count}} résultats',
  'tours.certificates.templates.title': 'Les modèles',
  'tours.certificates.templates.body': 'Choisissez le modèle à modifier. « Nouveau modèle » en crée un à nommer, « Dupliquer » copie la version enregistrée de celui affiché, « Définir par défaut » en fait le modèle des parcours qui n\'en choisissent pas. « Supprimer » demande confirmation et n\'existe pas pour le modèle par défaut ; les parcours du modèle supprimé reprennent le modèle par défaut. Avec des modifications non enregistrées, changer de modèle, en créer ou en dupliquer un demande d\'abord de les abandonner.',
  'certificates.field.name': 'Nom du modèle',
  'certificates.field.nameHelp': 'Pour vous y retrouver, il n\'est pas imprimé : c\'est le titre qui l\'est.',
  'certificates.templates.title': 'Modèles d\'attestation',
  'certificates.templates.current': 'Modèle affiché',
  'certificates.templates.defaultOption': '{{name}} (par défaut)',
  'certificates.templates.new': 'Nouveau modèle',
  'certificates.templates.duplicate': 'Dupliquer',
  'certificates.templates.makeDefault': 'Définir par défaut',
  'certificates.templates.defaultHelp': 'C\'est le modèle des parcours qui n\'en choisissent pas : il ne peut pas être supprimé.',
  'certificates.templates.newName': 'Nom du nouveau modèle',
  'certificates.templates.create': 'Créer',
  'certificates.templates.deleteTitle': 'Supprimer le modèle « {{name}} » ?',
  'certificates.templates.deleteBody': 'Les parcours qui l\'utilisent reprendront le modèle par défaut, y compris pour les attestations déjà obtenues.',
  'certificates.templates.error': 'L\'opération sur le modèle a échoué.',
  'certificates.templates.created': 'Modèle créé.',
  'certificates.templates.duplicated': 'Modèle dupliqué.',
  'certificates.templates.defaultSet': 'Modèle par défaut changé.',
  'certificates.templates.deleted': 'Modèle supprimé.',
  'sessions.certificateTemplate.label': 'Modèle d\'attestation',
  'sessions.certificateTemplate.default': 'Modèle par défaut de l\'organisation',
  'sessions.certificateTemplate.defaultNamed': 'Modèle par défaut de l\'organisation ({{name}})',
  'sessions.certificateTemplate.hint': 'S\'applique aussi aux attestations déjà obtenues dans ce parcours : elles sont générées à chaque téléchargement.',
  'certificates.templates.copyName': '{{name}} (copie)',
  'certificates.templates.loadError': 'Les modèles d\'attestation n\'ont pas pu être chargés. Rechargez la page.',
  'certificates.templates.discardTitle': 'Abandonner les modifications ?',
  'certificates.templates.discard': 'Abandonner',
  'certificates.templates.discardBody': 'Le modèle affiché a des modifications non enregistrées : elles seront perdues.',
  'common.routing.questions': 'Analyse des questions',
  'questions.title': 'Analyse des questions',
  'questions.intro': 'Les réponses que les modules enregistrent, question par question. Choisissez un module ; pour chaque apprenant, c\'est sa réponse la plus récente qui compte. Une question se reconnaît à l\'identifiant que le module lui donne.',
  'questions.module': 'Module',
  'questions.chooseModule': 'Choisir un module…',
  'questions.from': 'Du',
  'questions.to': 'Au',
  'questions.pickModule': 'Choisissez un module pour voir les réponses à ses questions.',
  'questions.empty': 'Aucune réponse enregistrée pour ce module sur ce périmètre. Certains modules n\'envoient pas leurs questions : c\'est un réglage de leur publication.',
  'questions.loadError': 'L\'analyse n\'a pas pu être chargée.',
  'questions.tableLabel': 'Réponses par question',
  'questions.column.question': 'Question',
  'questions.column.expected': 'Réponse attendue',
  'questions.column.respondents': 'Répondants',
  'questions.column.correctRate': 'Bonnes réponses',
  'questions.column.averageScore': 'Score moyen',
  'questions.column.brackets': 'Répartition des scores',
  'questions.bracket': '{{range}} % : {{count}}',
  'questions.export.questions': 'CSV par question',
  'questions.export.answers': 'CSV des réponses',
  'questions.export.pdf': 'Rapport PDF',
  'questions.export.pdfFailed': 'Le rapport n\'a pas pu être généré.',
  'questions.export.questionsFile': 'analyse-questions',
  'questions.export.answersFile': 'reponses-questions',
  'questions.csv.path': 'Parcours',
  'questions.csv.module': 'Unité d\'apprentissage',
  'questions.csv.respondents': 'Nombre de personnes',
  'questions.csv.question': 'Intitulé',
  'questions.csv.questionId': 'Identifiant de la question',
  'questions.csv.expected': 'Réponse attendue',
  'questions.csv.averageScore': 'Score moyen',
  'questions.csv.learnerResponse': '{{name}} — réponse',
  'questions.csv.learnerScore': '{{name}} — score',
  'questions.csv.learner': 'Apprenant',
  'questions.csv.email': 'E-mail',
  'questions.csv.response': 'Réponse',
  'questions.csv.result': 'Résultat',
  'questions.csv.score': 'Score',
  'questions.csv.attempt': 'Tentative',
  'tours.sessionDetail.title': 'Fiche session',
  'tours.sessionDetail.description': 'Consulter une session : sa configuration, son parcours, ses participants et ses résultats.',
  'tours.sessionDetail.header.title': 'La session',
  'tours.sessionDetail.header.body': 'Son nom, son statut (« Activé » ou « Archivée »), ses dates de début et de fin, et ses étiquettes. La fiche s\'ouvre en cliquant sur le nom d\'une session dans la liste des sessions.',
  'tours.sessionDetail.edit.title': 'Modifier',
  'tours.sessionDetail.edit.body': 'Ouvre le formulaire de la session, le même que dans la liste : c\'est là, et seulement là, qu\'on la change. Validez avec « Enregistrer ». Le bouton n\'apparaît qu\'à qui peut gérer les sessions.',
  'tours.sessionDetail.kpis.title': 'Indicateurs',
  'tours.sessionDetail.kpis.body': 'Les chiffres du tableau de bord, restreints à cette session : participants, avancement module par module, taux de réussite, score moyen, temps moyen, temps total en formation et taux d\'abandon. Ce bloc, le tableau des participants et les exports demandent l\'accès aux statistiques.',
  'tours.sessionDetail.survey.title': 'Satisfaction',
  'tours.sessionDetail.survey.body': 'Ce que les apprenants ont dit du parcours, sans aucun nom : le questionnaire leur est proposé, sans obligation, juste avant leur attestation. Le taux de satisfaction compte les notes de 4 et 5 à la question de satisfaction globale ; viennent ensuite la moyenne de chaque question, la note de chaque module (l\'évaluation des contenus) et les commentaires.',
  'tours.sessionDetail.info.title': 'Informations',
  'tours.sessionDetail.info.body': 'Date de création, mode de progression (libre ou séquentiel) et ce qu\'exige l\'attestation, avec le modèle d\'attestation utilisé.',
  'tours.sessionDetail.trainers.title': 'Formateurs',
  'tours.sessionDetail.trainers.body': 'Qui anime la session : nom, rôle (formateur ou administrateur) et adresse email de chacun — un formateur ne voit pas celle d\'un administrateur. Ils se choisissent dans le formulaire de la session (« Modifier », puis « Enregistrer »). L\'affectation est indicative : elle ne change pas les droits de chacun.',
  'tours.sessionDetail.path.title': 'Le parcours',
  'tours.sessionDetail.path.body': 'Les modules dans l\'ordre, chapitre par chapitre, avec leurs verrous : le module à terminer avant (et le score minimum exigé) ou la date d\'ouverture. À droite, combien de participants ont terminé chaque module.',
  'tours.sessionDetail.participants.title': 'Les participants',
  'tours.sessionDetail.participants.body': 'Une ligne par inscrit : nom et adresse email, groupes, avancement, modules terminés, score moyen, temps passé et dernière activité. Sous le tableau : « Précédent » et « Suivant » pour changer de page, et le nombre de lignes par page.',
  'tours.sessionDetail.filter.title': 'Filtrer par avancement',
  'tours.sessionDetail.filter.body': 'Ne garder que les participants jamais commencés, en cours, terminés ou en abandon.',
  'tours.sessionDetail.exports.title': 'Exports',
  'tours.sessionDetail.exports.body': '« Résultats (CSV) » télécharge les participants affichés, filtre compris ; « Rapport PDF », le rapport d\'activité de la session. Ces deux boutons demandent le droit d\'exporter les statistiques. « Analyse des questions » ouvre l\'analyse filtrée sur cette session.',
  'tours.sessionDetail.attendance.title': 'Relevés d\'assiduité',
  'tours.sessionDetail.attendance.body': 'Un PDF avec le relevé de chaque inscrit, une page par apprenant : temps mesuré par module, tentatives, dates, scores, jours de connexion, méthode de mesure et attestation de l\'organisme. C\'est la preuve que la formation à distance a été suivie (Qualiopi, indicateur 19). Réservé aux administrateurs.',
  'tours.sessionDetail.dropout.title': 'Déclarer un abandon',
  'tours.sessionDetail.dropout.body': 'Sur la ligne d\'un apprenant parti : « Déclarer un abandon », choisissez le motif, ajoutez une précision si besoin, puis « Déclarer l\'abandon ». Il ne reçoit plus de rappels et sort des alertes de retard ; ses résultats restent. « Annuler l\'abandon » le remet dans la formation. Le taux d\'abandon s\'affiche dans les indicateurs, avec sa méthode de calcul. Réservé à qui peut gérer les sessions.',
  'tours.questions.title': 'Analyse des questions',
  'tours.questions.description': 'Voir comment les apprenants répondent à chaque question d\'un module, et l\'exporter.',
  'tours.questions.filters.title': 'Module et filtres',
  'tours.questions.filters.body': 'Choisissez d\'abord le module à analyser : rien ne s\'affiche avant. Un parcours restreint la liste à ses modules ; le groupe et la période (du… au…, dates de réponse) restreignent les apprenants comptés. Tout s\'applique aussitôt.',
  'tours.questions.table.title': 'Les questions',
  'tours.questions.table.body': 'Une fois le module choisi, une ligne par question, dans l\'ordre du module : la réponse attendue, le nombre de répondants, la part de bonnes réponses, le score moyen et la répartition des scores. Pour un apprenant, seule sa réponse la plus récente compte. Sous le tableau : « Précédent » et « Suivant » pour changer de page, et le nombre de lignes par page.',
  'tours.questions.exports.title': 'Exporter',
  'tours.questions.exports.body': 'Actifs dès qu\'il y a des réponses. « CSV par question » met une ligne par question, avec sa synthèse puis la réponse et le score de chaque apprenant ; « CSV des réponses » met une réponse par ligne ; « Rapport PDF » télécharge la même analyse en PDF. Les trois suivent les filtres de l\'écran.',
  'questions.learners_one': '{{count}} apprenant a répondu',
  'questions.learners_other': '{{count}} apprenants ont répondu',
  'questions.learner.title': 'Réponses de l\'apprenant',
  'questions.learner.attempt': 'Tentative {{number}} — {{path}}',
  'questions.learner.answer': 'Sa réponse',
  'questions.learner.result': 'Résultat',
  'questions.learner.noAnswer': 'Aucune réponse enregistrée pendant cette tentative.',
  'questions.learner.empty': 'Aucune tentative sur ce module.',
  'questions.learner.loadError': 'Les réponses n\'ont pas pu être chargées.',
  'tours.questions.learners.title': 'Les réponses d\'un apprenant',
  'tours.questions.learners.body': 'Les apprenants qui ont répondu, à retrouver par la recherche. Chacun ouvre un panneau avec ses tentatives sur le module — parcours, statut, score, date — et, pour chacune, ses réponses question par question. Sous la liste : « Précédent » et « Suivant » pour changer de page, et le nombre de lignes par page.',
  'questions.periodReversed': 'La date de début est après la date de fin.',
  'questions.export.failed': 'L\'export n\'a pas pu être généré.',
  'tours.dashboard.table.title': 'Le suivi par apprenant',
  'tours.dashboard.table.body': 'Une ligne par apprenant et par module de parcours, à chercher, filtrer par parcours ou par groupe, rafraîchir (flèches) et exporter en CSV. Un score corrigé porte la mention « corrigé », et l\'export le signale. L\'admin le corrige avec le crayon de la colonne Score : un score en %, un motif obligatoire, puis « Enregistrer la correction » ; le panneau garde l\'historique et permet d\'annuler la correction en vigueur.',
  'scoreCorrection.title': 'Corriger le score',
  'scoreCorrection.open': 'Corriger le score de {{name}}',
  'scoreCorrection.corrected': 'corrigé',
  'scoreCorrection.current': 'Score en vigueur',
  'scoreCorrection.inForce': 'Ce score est une correction : il prime sur les tentatives, même nouvelles, jusqu\'à son annulation.',
  'scoreCorrection.revoke': 'Annuler la correction',
  'scoreCorrection.revokeTitle': 'Annuler la correction ?',
  'scoreCorrection.revokeBody': 'Le score redevient celui calculé depuis les tentatives de l\'apprenant. La correction reste dans l\'historique.',
  'scoreCorrection.new': 'Nouvelle correction',
  'scoreCorrection.percent': 'Score corrigé (%)',
  'scoreCorrection.reason': 'Motif',
  'scoreCorrection.reasonHelp': 'Gardé dans l\'historique, avec votre nom et la date.',
  'scoreCorrection.save': 'Enregistrer la correction',
  'scoreCorrection.history': 'Historique',
  'scoreCorrection.noHistory': 'Aucune correction pour ce score.',
  'scoreCorrection.entry': '{{from}} → {{to}}',
  'scoreCorrection.by': 'Par {{who}}, le {{when}}',
  'scoreCorrection.ended': 'Close par {{who}}, le {{when}}',
  'scoreCorrection.deletedAccount': 'un compte supprimé',
  'scoreCorrection.saved': 'Correction enregistrée.',
  'scoreCorrection.revoked': 'Correction annulée.',
  'scoreCorrection.error': 'L\'opération sur le score a échoué.',
  'scoreCorrection.loadError': 'L\'historique n\'a pas pu être chargé.',
  'scoreCorrection.csvColumn': 'Score corrigé',
  'scoreCorrection.csvYes': 'oui',
  'scorm.chapters.label': 'Chapitre',
  'scorm.chapters.option': '{{position}}. {{title}}',
  'scorm.chapters.optionDone': '{{position}}. {{title}} — terminé',
  'scorm.chapters.finishedTitle': 'Chapitre terminé',
  'scorm.chapters.next': 'Chapitre suivant : {{title}}',
  'help.demo.chapters.intro': 'Introduction',
  'help.demo.chapters.basics': 'Les bases',
  'help.demo.chapters.quiz': 'Quiz final',
  'tours.player.chapters.title': 'Les chapitres',
  'tours.player.chapters.body': 'Quand le module compte plusieurs chapitres, choisissez-en un dans la liste puis « Ouvrir », dans l\'ordre que vous voulez ; ceux que vous avez finis sont marqués « terminé ». Vous reprenez là où vous en étiez dans chacun, et le module est terminé quand tous ses chapitres le sont.',
  'scorm.chapters.open': 'Ouvrir',
  'scorm.chapters.switching': 'Ouverture du chapitre…',
  'scorm.chapters.leftTitle': 'Chapitre interrompu',
  'tours.preview.chapters.title': 'Les chapitres',
  'tours.preview.chapters.body': 'Quand le paquet compte plusieurs chapitres (SCO), choisissez-en un puis « Ouvrir » pour vérifier chacun ; ici aussi, rien n\'est enregistré.',
  // Fiche apprenant (#242)
  'profile.back': 'Retour aux utilisateurs',
  'profile.notFound': 'Cet utilisateur est introuvable.',
  'profile.email': 'Écrire',
  'profile.indicators.title': 'Indicateurs',
  'profile.indicators.trainingTime': 'Temps en formation',
  'profile.indicators.trainingTimeHint': 'Temps passé dans les modules',
  'profile.indicators.logins': 'Connexions',
  'profile.indicators.loginsHint': 'Sur les 12 derniers mois',
  'profile.indicators.lastLogin': 'Dernière connexion',
  'profile.indicators.noLogin': 'Aucune connexion enregistrée',
  'profile.indicators.lastLoginTime': 'à {{time}}',
  'profile.indicators.frequency': 'Fréquence',
  'profile.indicators.frequencyValue': '{{days}} j',
  'profile.indicators.frequencyHint': 'Écart moyen entre deux connexions',
  'profile.indicators.frequencyNone': 'Il faut au moins deux connexions',
  'profile.indicators.progress': 'Progression',
  'profile.indicators.progressHint': '{{done}} modules terminés sur {{total}}',
  'profile.info.title': 'Informations',
  'profile.info.createdAt': 'Compte créé le',
  'profile.groups.empty': 'N’appartient à aucun groupe.',
  'profile.sessions.title': 'Sessions',
  'profile.sessions.timeSpent': 'Temps passé',
  'profile.sessions.finishedAt': 'Terminée le',
  'profile.sessions.actions': 'Actions',
  'profile.sessions.progressValue': '{{done}}/{{total}} ({{pct}} %)',
  'profile.certificates.title': 'Attestations',
  'profile.certificates.empty': 'Aucune attestation obtenue pour l’instant.',
  'profile.certificates.download': 'Télécharger',
  'profile.certificates.downloadFor': 'Télécharger l’attestation de « {{name}} »',
  'profile.positioning.title': 'Positionnement',
  'profile.positioning.empty': 'Aucun parcours ne lui demande de positionnement.',
  'profile.positioning.awaiting': 'Positionnement d\'entrée pas encore rempli.',
  'profile.positioning.tableFor': 'Positionnement sur « {{name}} »',
  'profile.positioning.objective': 'Objectif',
  'profile.positioning.entry': 'Entrée',
  'profile.positioning.exit': 'Sortie',
  'profile.positioning.gap': 'Écart',
  'profile.positioning.needs': 'Attentes à l\'entrée :',
  'profile.logins.title': 'Connexions',
  'profile.logins.retention': 'Les connexions sont conservées 12 mois.',
  'profile.logins.at': 'Date',
  'profile.logins.method': 'Moyen de connexion',
  'profile.logins.methods.PASSWORD': 'Mot de passe',
  'profile.logins.methods.MAGIC_LINK': 'Lien de connexion',
  'profile.logins.methods.SSO': 'SSO',
  'tours.learnerProfile.title': 'Fiche utilisateur',
  'tours.learnerProfile.description': 'Tout ce que l’on sait d’une personne, sur une seule page.',
  'tours.learnerProfile.header.title': 'La personne',
  'tours.learnerProfile.header.body': 'Son nom, son rôle et le statut de son compte. « Écrire » ouvre votre messagerie ; l’admin peut aussi consulter son espace, et réinitialiser le mot de passe d’un apprenant en pseudo.',
  'tours.learnerProfile.indicators.title': 'Les indicateurs',
  'tours.learnerProfile.indicators.body': 'Le temps passé dans les modules, les connexions des 12 derniers mois, la dernière, l’écart moyen entre deux connexions et la progression sur l’ensemble de ses sessions.',
  'tours.learnerProfile.info.title': 'Les informations',
  'tours.learnerProfile.info.body': 'Son compte, en lecture, avec sa société et son service. L’admin le corrige avec « Modifier » : la modification s’enregistre dans la fenêtre qui s’ouvre.',
  'tours.learnerProfile.groups.title': 'Les groupes',
  'tours.learnerProfile.groups.body': 'Les groupes dont elle fait partie. Ils se gèrent depuis l’écran Groupes ou la liste des utilisateurs.',
  'tours.learnerProfile.sessions.title': 'Les sessions',
  'tours.learnerProfile.sessions.body': 'Une ligne par session : état, progression, score (pour une formation à un seul module), temps passé et date de fin.',
  'tours.learnerProfile.attendance.title': 'Le relevé d\'assiduité',
  'tours.learnerProfile.attendance.body': '« Relevé d\'assiduité », sur la ligne d\'une session, télécharge en PDF ce que l\'apprenant a suivi : temps mesuré par module, tentatives, dates, scores, jours de connexion, avec l\'attestation de l\'organisme. Réservé aux administrateurs.',
  'tours.learnerProfile.certificates.title': 'Les attestations',
  'tours.learnerProfile.certificates.body': 'Les attestations qu’elle a obtenues, à télécharger en PDF.',
  'tours.learnerProfile.positioning.title': 'Le positionnement',
  'tours.learnerProfile.positioning.body': 'Pour chaque parcours qui le demande : le niveau que l\'apprenant s\'est donné sur chaque objectif à l\'entrée, puis à la sortie s\'il s\'est réévalué, l\'écart entre les deux, et les attentes qu\'il a exprimées au départ. C\'est la trace du positionnement et de l\'atteinte des objectifs que demande Qualiopi (indicateurs 8 et 11).',
  'tours.learnerProfile.logins.title': 'Les connexions',
  'tours.learnerProfile.logins.body': 'Ses connexions des 12 derniers mois et le moyen utilisé : mot de passe, lien de connexion ou SSO. Au-delà, elles sont effacées.',
  'helpDemo.learner.group': 'Équipe commerciale',
  'helpDemo.learner.course': 'Sécurité au poste de travail',
  'helpDemo.learner.positioning.needs': 'Être à l\'aise pour accueillir le public dès la première semaine.',
  'helpDemo.learner.positioning.objective1': 'Accueillir un visiteur selon la procédure',
  'helpDemo.learner.positioning.objective2': 'Orienter une demande vers le bon service',
  'helpDemo.path.documents.rules': 'Règlement intérieur',
  'helpDemo.path.documents.booklet': 'Livret d\'accueil',
  'profile.loadError': 'La fiche n’a pas pu être chargée.',
  'profile.retry': 'Réessayer',

  // Rapports configurables (#163)
  'common.routing.reports': 'Rapports',
  'nav.group.statistics': 'Statistiques',
  'reports.title': 'Rapports',
  'reports.loadError': 'Les modèles de rapport n\'ont pas pu être chargés.',
  'reports.error': 'L\'opération a échoué. Réessayez.',
  'reports.downloadFailed': 'Le rapport n\'a pas pu être téléchargé.',
  'reports.tooLarge': 'Ce rapport dépasse 50 000 lignes : restreignez-le par parcours, groupe, état ou période.',
  'reports.created': 'Modèle créé',
  'reports.saved': 'Modèle enregistré',
  'reports.duplicated': 'Modèle dupliqué',
  'reports.deleted': 'Modèle supprimé',
  'reports.copyName': 'Copie de {{name}}',
  'reports.discardTitle': 'Abandonner les modifications ?',
  'reports.discardBody': 'Le modèle en cours d\'édition n\'est pas enregistré : ses modifications seront perdues.',
  'reports.discard': 'Abandonner',
  'reports.list.title': 'Modèles de rapport',
  'reports.list.empty': 'Aucun modèle de rapport pour l\'instant : un administrateur peut en composer.',
  'reports.list.emptyAdmin': 'Aucun modèle de rapport pour l\'instant : composez le premier ci-dessous.',
  'reports.list.name': 'Nom',
  'reports.list.granularity': 'Une ligne par',
  'reports.list.columns': 'Colonnes',
  'reports.list.actions': 'Actions',
  'reports.list.download': 'Télécharger',
  'reports.list.edit': 'Modifier « {{name}} »',
  'reports.list.duplicate': 'Dupliquer « {{name}} »',
  'reports.list.delete': 'Supprimer « {{name}} »',
  'reports.list.deleteTitle': 'Supprimer le modèle « {{name}} » ?',
  'reports.list.deleteBody': 'Le modèle disparaît pour tous ; les fichiers déjà téléchargés ne sont pas touchés.',
  'reports.editor.newTitle': 'Nouveau modèle',
  'reports.editor.editTitle': 'Modifier « {{name}} »',
  'reports.editor.name': 'Nom du modèle',
  'reports.editor.granularity': 'Une ligne par',
  'reports.editor.create': 'Créer le modèle',
  'reports.editor.newInstead': 'Nouveau modèle',
  'reports.granularity.LEARNER': 'Apprenant',
  'reports.granularity.ENROLLMENT': 'Parcours d\'un apprenant',
  'reports.granularity.MODULE': 'Module d\'un parcours',
  'reports.granularityHelp.LEARNER': 'Une ligne par apprenant, ses parcours additionnés : nombre de parcours, temps total, état d\'ensemble.',
  'reports.granularityHelp.ENROLLMENT': 'Une ligne par apprenant et par parcours où il est inscrit.',
  'reports.granularityHelp.MODULE': 'Une ligne par module de chaque parcours, y compris ceux jamais ouverts.',
  'reports.level.learner': 'Apprenant',
  'reports.level.enrollment': 'Parcours',
  'reports.level.module': 'Module',
  'reports.columns.order': 'Ordre des colonnes dans le fichier',
  'reports.columns.required': 'Cochez au moins une colonne.',
  'reports.columns.up': 'Monter « {{column}} »',
  'reports.columns.down': 'Descendre « {{column}} »',
  'reports.filters.sessions': 'Parcours (aucun coché : tous)',
  'reports.filters.groups': 'Groupes (aucun coché : tous)',
  'reports.filters.noSessions': 'Aucun parcours pour l\'instant.',
  'reports.filters.noGroups': 'Aucun groupe pour l\'instant.',
  'reports.filters.state': 'État',
  'reports.filters.anyState': 'Tous les états',
  'reports.filters.period': 'Période d\'activité',
  'reports.filters.from': 'Du',
  'reports.filters.to': 'Au',
  'reports.filters.periodInvalid': 'Indiquez au moins une date, et un début avant la fin.',
  'reports.filters.periodHelp': 'Ne garde que les lignes dont la dernière activité tombe dans la période, recalculée à chaque téléchargement.',
  'reports.list.schedule': 'Envoi par mail',
  'reports.schedule.title': 'Envoi par mail',
  'reports.schedule.description': 'Recevez ce rapport automatiquement, en pièce jointe CSV, à l\'heure de l\'organisation.',
  'reports.schedule.saveFirst': 'Créez d\'abord le modèle, puis ouvrez-le depuis la liste (crayon) pour programmer son envoi.',
  'reports.schedule.enabled': 'Envoyer ce rapport par mail',
  'reports.schedule.frequency': 'Fréquence',
  'reports.schedule.frequencies.WEEKLY': 'Chaque semaine',
  'reports.schedule.frequencies.MONTHLY': 'Chaque mois',
  'reports.schedule.weekday': 'Jour',
  'reports.schedule.monthDay': 'Jour du mois',
  'reports.schedule.hour': 'Heure',
  'reports.schedule.hourOption': '{{hour}} h',
  'reports.schedule.weekdays.1': 'Lundi',
  'reports.schedule.weekdays.2': 'Mardi',
  'reports.schedule.weekdays.3': 'Mercredi',
  'reports.schedule.weekdays.4': 'Jeudi',
  'reports.schedule.weekdays.5': 'Vendredi',
  'reports.schedule.weekdays.6': 'Samedi',
  'reports.schedule.weekdays.7': 'Dimanche',
  'reports.schedule.recipients': 'Destinataires',
  'reports.schedule.recipientsSearch': 'Rechercher un destinataire',
  'reports.schedule.recipientsRequired': 'Cochez au moins un destinataire.',
  'reports.schedule.lastSent': 'Dernier envoi : {{date}}',
  'reports.schedule.save': 'Enregistrer l\'envoi',
  'reports.schedule.stop': 'Supprimer l\'envoi',
  'reports.schedule.saved': 'Envoi enregistré',
  'reports.schedule.stopped': 'Envoi supprimé',
  'reports.schedule.summary.WEEKLY': 'Hebdomadaire : {{day}}, {{hour}} h',
  'reports.schedule.summary.MONTHLY': 'Mensuel : le {{day}}, {{hour}} h',
  'tours.reports.schedule.title': 'Envoi par mail',
  'tours.reports.schedule.body': 'Pour un modèle existant, ouvert depuis la liste : choisissez chaque semaine (un jour) ou chaque mois (du 1 au 28), une heure, et les administrateurs qui le recevront en pièce jointe CSV — ou les formateurs, tant que l\'organisation leur laisse exporter les statistiques. Cliquez sur « Enregistrer l\'envoi » ; décochez « Envoyer ce rapport par mail » pour le suspendre, ou « Supprimer l\'envoi » pour l\'arrêter. Un rapport trop gros arrive sans pièce jointe, avec un lien vers cet écran.',
  'reports.state.NOT_STARTED': 'Non commencé',
  'reports.state.IN_PROGRESS': 'En cours',
  'reports.state.COMPLETED': 'Terminé',
  'reports.period.ALL': 'Toute la période',
  'reports.period.LAST_7_DAYS': '7 derniers jours',
  'reports.period.LAST_30_DAYS': '30 derniers jours',
  'reports.period.CURRENT_MONTH': 'Mois en cours',
  'reports.period.PREVIOUS_MONTH': 'Mois précédent',
  'reports.period.RANGE': 'Dates choisies',
  'tours.reports.title': 'Rapports',
  'tours.reports.description': 'Télécharger les rapports CSV de l\'organisation et, pour un administrateur, composer leurs modèles.',
  'tours.reports.list.title': 'Les modèles',
  'tours.reports.list.body': 'Les modèles de rapport de l\'organisation, par nom, avec ce qu\'est une ligne et le nombre de colonnes. La colonne « Envoi par mail » dit quand il part. Un administrateur peut aussi les modifier (crayon), les dupliquer ou les supprimer.',
  'tours.reports.download.title': 'Télécharger',
  'tours.reports.download.body': '« Télécharger » produit le fichier CSV du modèle, avec les données du moment : les en-têtes sont dans la langue de l\'organisation, les dates à son heure. Le fichier ne contient que des apprenants. Au-delà de 50 000 lignes, le rapport est refusé : restreignez ses filtres.',
  'tours.reports.editor.title': 'Nommer le modèle',
  'tours.reports.editor.body': 'L\'éditeur compose un nouveau modèle, ou celui que vous avez choisi de modifier dans la liste. Donnez-lui un nom, obligatoire.',
  'tours.reports.granularity.title': 'Ce qu\'est une ligne',
  'tours.reports.granularity.body': 'Une ligne par apprenant, par parcours d\'un apprenant, ou par module de chaque parcours. Changer ce choix retire les colonnes qu\'il n\'autorise plus.',
  'tours.reports.columns.title': 'Les colonnes',
  'tours.reports.columns.body': 'Cochez les colonnes, rangées par apprenant, parcours et module : chaque case cochée s\'ajoute à la fin du fichier. À droite, les flèches changent leur ordre.',
  'tours.reports.filters.title': 'Les filtres',
  'tours.reports.filters.body': 'Restreignez le rapport à des parcours, à des groupes, à un état (non commencé, en cours, terminé) et à une période d\'activité. Une période comme « mois précédent » se recalcule à chaque téléchargement.',
  'tours.reports.save.title': 'Enregistrer',
  'tours.reports.save.body': '« Créer le modèle » ou « Enregistrer » le range dans la liste, prêt à télécharger. Rien n\'est gardé tant que vous n\'avez pas cliqué.',
  'credentials.title_one': 'Identifiants de l\'apprenant',
  'credentials.title_other': 'Identifiants de {{count}} apprenants',
  'credentials.once': 'Notez-les ou imprimez la fiche maintenant : le mot de passe ne sera plus affiché. En cas de perte, réinitialisez-le depuis la liste ou la fiche de l\'apprenant.',
  'credentials.copy': 'Copier le mot de passe de {{username}}',
  'credentials.copied': 'Mot de passe copié.',
  'credentials.copyFailed': 'Copie impossible : sélectionnez le mot de passe et copiez-le à la main.',
  'credentials.sheet.download': 'Télécharger la fiche',
  'credentials.sheet.failed': 'La fiche n\'a pas pu être générée. Réessayez.',
  'user.mode.label': 'Connexion de l\'apprenant',
  'user.mode.email': 'Adresse email',
  'user.mode.username': 'Pseudo et mot de passe',
  'user.mode.username.help': 'Pour un apprenant sans adresse email : il se connecte avec le pseudo et le mot de passe que vous lui remettez. Aucun email ne lui est envoyé.',
  'user.username.help': '3 à 64 caractères : lettres minuscules, chiffres, point, tiret ou trait de soulignement.',
  'user.username.invalid': 'Pseudo invalide : 3 à 64 caractères, lettres minuscules, chiffres, point, tiret ou trait de soulignement.',
  'user.username.taken': 'Ce pseudo est déjà utilisé dans votre organisation.',
  'user.password.optional.help': 'Laissez vide pour en générer un. Au moins 8 caractères sinon.',
  'user.password.tooShort': 'Au moins 8 caractères.',
  'user.nameOptional.help': 'Facultatifs : un pseudonyme suffit si vous ne voulez pas enregistrer de nom.',
  'good.add.usernameLearner': 'Apprenant créé.',
  'credentials.reset.action': 'Réinitialiser le mot de passe',
  'credentials.reset.title': 'Nouveau mot de passe pour {{username}} ?',
  'credentials.reset.body': 'Un mot de passe est généré et affiché une fois, à remettre à l\'apprenant. L\'ancien ne fonctionnera plus et ses sessions ouvertes seront fermées.',
  'credentials.reset.confirm': 'Réinitialiser',
  'credentials.reset.failed': 'Le mot de passe n\'a pas pu être réinitialisé.',
  'import.username.help': 'Fichier CSV avec les colonnes {{headers}} (séparateur point-virgule). Seul le pseudo est obligatoire. Un mot de passe est généré pour chaque apprenant ; aucun email n\'est envoyé.',
  'import.username.badHeader': 'En-têtes invalides. Attendu au moins : pseudo.',
  'import.error.INVALID_USERNAME': 'Pseudo invalide',
  'import.error.USERNAME_ALREADY_USED': 'Pseudo déjà utilisé',
  'import.username.tooMany': '500 lignes au plus par import : découpez le fichier.',
  'user.password.tooLong': '128 caractères au plus.',
  'user.company': 'Société',
  'user.department': 'Service',
  'import.error.AFFILIATION_TOO_LONG': 'Société ou service trop long (200 caractères au plus)',
  'signup.tagline': 'Formez.\nSuivez.\nCertifiez.',
  'signup.tagline.sub': 'Vos modules SCORM, vos apprenants et leurs attestations dans un même espace. Sans carte bancaire.',
  'signup.sent.next.title': 'Et ensuite ?',
  'signup.sent.next.confirm': 'Confirmez votre adresse en cliquant sur le lien de l\'e-mail.',
  'signup.sent.next.review': 'Notre équipe examine votre demande.',
  'signup.sent.next.access': 'Une fois validée, vous recevez un e-mail pour définir votre mot de passe et ouvrir votre espace, dont vous êtes le premier administrateur.',
}
